// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file wavin/sentio/v1/broker.proto (package wavin.sentio.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { BrokerValue } from "./heartbeat_pb";
import { file_wavin_sentio_v1_heartbeat } from "./heartbeat_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wavin/sentio/v1/broker.proto.
 */
export const file_wavin_sentio_v1_broker: GenFile = /*@__PURE__*/
  fileDesc("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", [file_wavin_sentio_v1_heartbeat]);

/**
 * BrokerConfig is the internal model
 *
 * @generated from message wavin.sentio.v1.BrokerConfig
 */
export type BrokerConfig = Message<"wavin.sentio.v1.BrokerConfig"> & {
  /**
   * @generated from field: repeated wavin.sentio.v1.BrokerValue broker_values = 1;
   */
  brokerValues: BrokerValue[];

  /**
   * @generated from field: bool full_config = 2;
   */
  fullConfig: boolean;
};

/**
 * Describes the message wavin.sentio.v1.BrokerConfig.
 * Use `create(BrokerConfigSchema)` to create a new message.
 */
export const BrokerConfigSchema: GenMessage<BrokerConfig> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_broker, 0);

/**
 * OIDX (Object Index) of OID (Object ID)
 * Valid for CCU-208, EU-208-A, DHW-21x and generic devices
 *
 * @generated from enum wavin.sentio.v1.OIDX
 */
export enum OIDX {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: OIDX_DEVICE = 0;
   */
  OIDX_DEVICE = 0,

  /**
   * @generated from enum value: OIDX_PUMP_1 = 1;
   */
  OIDX_PUMP_1 = 1,

  /**
   * @generated from enum value: OIDX_PUMP_2 = 2;
   */
  OIDX_PUMP_2 = 2,

  /**
   * @generated from enum value: OIDX_ANALOG_0_10V = 3;
   */
  OIDX_ANALOG_0_10V = 3,

  /**
   * @generated from enum value: OIDX_PWM_OUTPUT = 4;
   */
  OIDX_PWM_OUTPUT = 4,

  /**
   * @generated from enum value: OIDX_GPIO_1 = 5;
   */
  OIDX_GPIO_1 = 5,

  /**
   * @generated from enum value: OIDX_GPIO_2 = 6;
   */
  OIDX_GPIO_2 = 6,

  /**
   * @generated from enum value: OIDX_VFR_1 = 7;
   */
  OIDX_VFR_1 = 7,

  /**
   * @generated from enum value: OIDX_VFR_2 = 8;
   */
  OIDX_VFR_2 = 8,

  /**
   * @generated from enum value: OIDX_SERVO_1 = 9;
   */
  OIDX_SERVO_1 = 9,

  /**
   * @generated from enum value: OIDX_SERVO_2 = 10;
   */
  OIDX_SERVO_2 = 10,

  /**
   * @generated from enum value: OIDX_INPUT_1 = 11;
   */
  OIDX_INPUT_1 = 11,

  /**
   * @generated from enum value: OIDX_INPUT_2 = 12;
   */
  OIDX_INPUT_2 = 12,

  /**
   * @generated from enum value: OIDX_INPUT_3 = 13;
   */
  OIDX_INPUT_3 = 13,

  /**
   * @generated from enum value: OIDX_INPUT_4 = 14;
   */
  OIDX_INPUT_4 = 14,

  /**
   * @generated from enum value: OIDX_INPUT_5 = 15;
   */
  OIDX_INPUT_5 = 15,

  /**
   * @generated from enum value: OIDX_ITC_1 = 16;
   */
  OIDX_ITC_1 = 16,

  /**
   * @generated from enum value: OIDX_ITC_2 = 17;
   */
  OIDX_ITC_2 = 17,

  /**
   * @generated from enum value: OIDX_DHW_TANK = 20;
   */
  OIDX_DHW_TANK = 20,

  /**
   * @generated from enum value: OIDX_HCC_1 = 21;
   */
  OIDX_HCC_1 = 21,

  /**
   * @generated from enum value: OIDX_HCC_2 = 22;
   */
  OIDX_HCC_2 = 22,

  /**
   * @generated from enum value: OIDX_HCC_3 = 23;
   */
  OIDX_HCC_3 = 23,

  /**
   * @generated from enum value: OIDX_RJ_B_BUS = 26;
   */
  OIDX_RJ_B_BUS = 26,

  /**
   * @generated from enum value: OIDX_RJ_A = 27;
   */
  OIDX_RJ_A = 27,

  /**
   * @generated from enum value: OIDX_ETHERNET = 28;
   */
  OIDX_ETHERNET = 28,

  /**
   * @generated from enum value: OIDX_ROOM_1 = 32;
   */
  OIDX_ROOM_1 = 32,

  /**
   * @generated from enum value: OIDX_ROOM_2 = 33;
   */
  OIDX_ROOM_2 = 33,

  /**
   * @generated from enum value: OIDX_ROOM_3 = 34;
   */
  OIDX_ROOM_3 = 34,

  /**
   * @generated from enum value: OIDX_ROOM_4 = 35;
   */
  OIDX_ROOM_4 = 35,

  /**
   * @generated from enum value: OIDX_ROOM_5 = 36;
   */
  OIDX_ROOM_5 = 36,

  /**
   * @generated from enum value: OIDX_ROOM_6 = 37;
   */
  OIDX_ROOM_6 = 37,

  /**
   * @generated from enum value: OIDX_ROOM_7 = 38;
   */
  OIDX_ROOM_7 = 38,

  /**
   * @generated from enum value: OIDX_ROOM_8 = 39;
   */
  OIDX_ROOM_8 = 39,

  /**
   * @generated from enum value: OIDX_ROOM_9 = 40;
   */
  OIDX_ROOM_9 = 40,

  /**
   * @generated from enum value: OIDX_ROOM_10 = 41;
   */
  OIDX_ROOM_10 = 41,

  /**
   * @generated from enum value: OIDX_ROOM_11 = 42;
   */
  OIDX_ROOM_11 = 42,

  /**
   * @generated from enum value: OIDX_ROOM_12 = 43;
   */
  OIDX_ROOM_12 = 43,

  /**
   * @generated from enum value: OIDX_ROOM_13 = 44;
   */
  OIDX_ROOM_13 = 44,

  /**
   * @generated from enum value: OIDX_ROOM_14 = 45;
   */
  OIDX_ROOM_14 = 45,

  /**
   * @generated from enum value: OIDX_ROOM_15 = 46;
   */
  OIDX_ROOM_15 = 46,

  /**
   * @generated from enum value: OIDX_ROOM_16 = 47;
   */
  OIDX_ROOM_16 = 47,

  /**
   * @generated from enum value: OIDX_ROOM_17 = 48;
   */
  OIDX_ROOM_17 = 48,

  /**
   * @generated from enum value: OIDX_ROOM_18 = 49;
   */
  OIDX_ROOM_18 = 49,

  /**
   * @generated from enum value: OIDX_ROOM_19 = 50;
   */
  OIDX_ROOM_19 = 50,

  /**
   * @generated from enum value: OIDX_ROOM_20 = 51;
   */
  OIDX_ROOM_20 = 51,

  /**
   * @generated from enum value: OIDX_ROOM_21 = 52;
   */
  OIDX_ROOM_21 = 52,

  /**
   * @generated from enum value: OIDX_ROOM_22 = 53;
   */
  OIDX_ROOM_22 = 53,

  /**
   * @generated from enum value: OIDX_ROOM_23 = 54;
   */
  OIDX_ROOM_23 = 54,

  /**
   * @generated from enum value: OIDX_ROOM_24 = 55;
   */
  OIDX_ROOM_24 = 55,

  /**
   * @generated from enum value: OIDX_ROOM_25 = 56;
   */
  OIDX_ROOM_25 = 56,

  /**
   * @generated from enum value: OIDX_ROOM_26 = 57;
   */
  OIDX_ROOM_26 = 57,

  /**
   * @generated from enum value: OIDX_ROOM_27 = 58;
   */
  OIDX_ROOM_27 = 58,

  /**
   * @generated from enum value: OIDX_ROOM_28 = 59;
   */
  OIDX_ROOM_28 = 59,

  /**
   * @generated from enum value: OIDX_ROOM_29 = 60;
   */
  OIDX_ROOM_29 = 60,

  /**
   * @generated from enum value: OIDX_ROOM_30 = 61;
   */
  OIDX_ROOM_30 = 61,

  /**
   * @generated from enum value: OIDX_ROOM_31 = 62;
   */
  OIDX_ROOM_31 = 62,

  /**
   * @generated from enum value: OIDX_ROOM_32 = 63;
   */
  OIDX_ROOM_32 = 63,

  /**
   * @generated from enum value: OIDX_OUTPUT_1 = 64;
   */
  OIDX_OUTPUT_1 = 64,

  /**
   * @generated from enum value: OIDX_OUTPUT_2 = 65;
   */
  OIDX_OUTPUT_2 = 65,

  /**
   * @generated from enum value: OIDX_OUTPUT_3 = 66;
   */
  OIDX_OUTPUT_3 = 66,

  /**
   * @generated from enum value: OIDX_OUTPUT_4 = 67;
   */
  OIDX_OUTPUT_4 = 67,

  /**
   * @generated from enum value: OIDX_OUTPUT_5 = 68;
   */
  OIDX_OUTPUT_5 = 68,

  /**
   * @generated from enum value: OIDX_OUTPUT_6 = 69;
   */
  OIDX_OUTPUT_6 = 69,

  /**
   * @generated from enum value: OIDX_OUTPUT_7 = 70;
   */
  OIDX_OUTPUT_7 = 70,

  /**
   * @generated from enum value: OIDX_OUTPUT_8 = 71;
   */
  OIDX_OUTPUT_8 = 71,

  /**
   * @generated from enum value: OIDX_PWM_INPUT = 72;
   */
  OIDX_PWM_INPUT = 72,

  /**
   * @generated from enum value: OIDX_UPDATE_CTRL = 73;
   */
  OIDX_UPDATE_CTRL = 73,

  /**
   * @generated from enum value: OIDX_PROFILE = 74;
   */
  OIDX_PROFILE = 74,

  /**
   * @generated from enum value: OIDX_AGGREGATED = 75;
   */
  OIDX_AGGREGATED = 75,

  /**
   * @generated from enum value: OIDX_HC_WATER_SOURCE = 76;
   */
  OIDX_HC_WATER_SOURCE = 76,

  /**
   * @generated from enum value: OIDX_HEAT_PUMP_1 = 77;
   */
  OIDX_HEAT_PUMP_1 = 77,

  /**
   * @generated from enum value: OIDX_HEAT_PUMP_2 = 78;
   */
  OIDX_HEAT_PUMP_2 = 78,

  /**
   * @generated from enum value: OIDX_VELUX_CTRL = 80;
   */
  OIDX_VELUX_CTRL = 80,

  /**
   * @generated from enum value: OIDX_DEHUMIDIFIER_1 = 81;
   */
  OIDX_DEHUMIDIFIER_1 = 81,

  /**
   * @generated from enum value: OIDX_DEHUMIDIFIER_2 = 82;
   */
  OIDX_DEHUMIDIFIER_2 = 82,

  /**
   * @generated from enum value: OIDX_DEHUMIDIFIER_3 = 83;
   */
  OIDX_DEHUMIDIFIER_3 = 83,

  /**
   * @generated from enum value: OIDX_DEHUMIDIFIER_4 = 84;
   */
  OIDX_DEHUMIDIFIER_4 = 84,

  /**
   * @generated from enum value: OIDX_DRYER_1 = 85;
   */
  OIDX_DRYER_1 = 85,

  /**
   * @generated from enum value: OIDX_DRYER_2 = 86;
   */
  OIDX_DRYER_2 = 86,

  /**
   * @generated from enum value: OIDX_DRYER_3 = 87;
   */
  OIDX_DRYER_3 = 87,

  /**
   * @generated from enum value: OIDX_DRYER_4 = 88;
   */
  OIDX_DRYER_4 = 88,

  /**
   * @generated from enum value: OIDX_INTEGRATION_1 = 89;
   */
  OIDX_INTEGRATION_1 = 89,

  /**
   * @generated from enum value: OIDX_INTEGRATION_2 = 90;
   */
  OIDX_INTEGRATION_2 = 90,

  /**
   * @generated from enum value: OIDX_INTEGRATION_3 = 91;
   */
  OIDX_INTEGRATION_3 = 91,

  /**
   * @generated from enum value: OIDX_INTEGRATION_4 = 92;
   */
  OIDX_INTEGRATION_4 = 92,

  /**
   * @generated from enum value: OIDX_MECH_VENTILATION_1 = 93;
   */
  OIDX_MECH_VENTILATION_1 = 93,

  /**
   * @generated from enum value: OIDX_MECH_VENTILATION_2 = 94;
   */
  OIDX_MECH_VENTILATION_2 = 94,

  /**
   * @generated from enum value: OIDX_LOCATION = 254;
   */
  OIDX_LOCATION = 254,
}

/**
 * Describes the enum wavin.sentio.v1.OIDX.
 */
export const OIDXSchema: GenEnum<OIDX> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 0);

/**
 * OIDX_VFR (Object Index) of OID (Object ID)
 * Valid EU-206-VFR
 * buf:lint:ignore ENUM_PASCAL_CASE
 *
 * @generated from enum wavin.sentio.v1.OIDX_VFR
 */
export enum OIDX_VFR {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: OIDX_VFR_DEVICE = 0;
   */
  OIDX_VFR_DEVICE = 0,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_1 = 1;
   */
  OIDX_VFR_OUTPUT_1 = 1,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_2 = 2;
   */
  OIDX_VFR_OUTPUT_2 = 2,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_3 = 3;
   */
  OIDX_VFR_OUTPUT_3 = 3,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_4 = 4;
   */
  OIDX_VFR_OUTPUT_4 = 4,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_5 = 5;
   */
  OIDX_VFR_OUTPUT_5 = 5,

  /**
   * @generated from enum value: OIDX_VFR_OUTPUT_6 = 6;
   */
  OIDX_VFR_OUTPUT_6 = 6,
}

/**
 * Describes the enum wavin.sentio.v1.OIDX_VFR.
 */
export const OIDX_VFRSchema: GenEnum<OIDX_VFR> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 1);

/**
 * OIDX_DHW_201 (Object Index) of OID (Object ID)
 * Valid for DHW-201
 * buf:lint:ignore ENUM_PASCAL_CASE
 *
 * @generated from enum wavin.sentio.v1.OIDX_DHW_201
 */
export enum OIDX_DHW_201 {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: OIDX_DHW_201_DEVICE = 0;
   */
  OIDX_DHW_201_DEVICE = 0,

  /**
   * @generated from enum value: OIDX_DHW_201_CONTROLLER = 1;
   */
  OIDX_DHW_201_CONTROLLER = 1,
}

/**
 * Describes the enum wavin.sentio.v1.OIDX_DHW_201.
 */
export const OIDX_DHW_201Schema: GenEnum<OIDX_DHW_201> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 2);

/**
 * OIDX_DHW_21X (Object Index) of OID (Object ID)
 * Valid for DHW-21X models
 * buf:lint:ignore ENUM_PASCAL_CASE
 *
 * @generated from enum wavin.sentio.v1.OIDX_DHW_21X
 */
export enum OIDX_DHW_21X {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: OIDX_DHW_21X_DEVICE = 0;
   */
  OIDX_DHW_21X_DEVICE = 0,

  /**
   * @generated from enum value: OIDX_DHW_21X_CONTROLLER = 20;
   */
  OIDX_DHW_21X_CONTROLLER = 20,

  /**
   * @generated from enum value: OIDX_DHW_21X_PUMP_1 = 1;
   */
  OIDX_DHW_21X_PUMP_1 = 1,

  /**
   * @generated from enum value: OIDX_DHW_21X_PUMP_2 = 2;
   */
  OIDX_DHW_21X_PUMP_2 = 2,

  /**
   * @generated from enum value: OIDX_DHW_21X_PUMP_3 = 3;
   */
  OIDX_DHW_21X_PUMP_3 = 3,

  /**
   * @generated from enum value: OIDX_DHW_21X_PUMP_PWM = 4;
   */
  OIDX_DHW_21X_PUMP_PWM = 4,

  /**
   * @generated from enum value: OIDX_DHW_21X_SERVO_1 = 9;
   */
  OIDX_DHW_21X_SERVO_1 = 9,

  /**
   * @generated from enum value: OIDX_DHW_21X_SERVO_2 = 10;
   */
  OIDX_DHW_21X_SERVO_2 = 10,

  /**
   * @generated from enum value: OIDX_DHW_21X_INPUT_1 = 11;
   */
  OIDX_DHW_21X_INPUT_1 = 11,

  /**
   * @generated from enum value: OIDX_DHW_21X_INPUT_2 = 12;
   */
  OIDX_DHW_21X_INPUT_2 = 12,

  /**
   * @generated from enum value: OIDX_DHW_21X_INPUT_3 = 13;
   */
  OIDX_DHW_21X_INPUT_3 = 13,

  /**
   * @generated from enum value: OIDX_DHW_21X_ITC_1 = 16;
   */
  OIDX_DHW_21X_ITC_1 = 16,

  /**
   * @generated from enum value: OIDX_DHW_21X_HCC_1 = 21;
   */
  OIDX_DHW_21X_HCC_1 = 21,

  /**
   * @generated from enum value: OIDX_DHW_21X_GUI = 24;
   */
  OIDX_DHW_21X_GUI = 24,

  /**
   * @generated from enum value: OIDX_DHW_21X_RJ_B = 26;
   */
  OIDX_DHW_21X_RJ_B = 26,

  /**
   * @generated from enum value: OIDX_DHW_21X_RJ_A = 27;
   */
  OIDX_DHW_21X_RJ_A = 27,

  /**
   * @generated from enum value: OIDX_DHW_21X_ETHERNET = 28;
   */
  OIDX_DHW_21X_ETHERNET = 28,

  /**
   * @generated from enum value: OIDX_DHW_21X_USB = 29;
   */
  OIDX_DHW_21X_USB = 29,

  /**
   * @generated from enum value: OIDX_DHW_21X_OPEN_THERM = 30;
   */
  OIDX_DHW_21X_OPEN_THERM = 30,

  /**
   * @generated from enum value: OIDX_DHW_21X_MBUS = 31;
   */
  OIDX_DHW_21X_MBUS = 31,

  /**
   * @generated from enum value: OIDX_DHW_21X_ROOM_1 = 32;
   */
  OIDX_DHW_21X_ROOM_1 = 32,

  /**
   * @generated from enum value: OIDX_DHW_21X_UPDATE_CTRL = 73;
   */
  OIDX_DHW_21X_UPDATE_CTRL = 73,
}

/**
 * Describes the enum wavin.sentio.v1.OIDX_DHW_21X.
 */
export const OIDX_DHW_21XSchema: GenEnum<OIDX_DHW_21X> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 3);

/**
 * Device type for Device Objects
 *
 * @generated from enum wavin.sentio.v1.DeviceType
 */
export enum DeviceType {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * CALEFA-I (District Heating)
   *
   * @generated from enum value: DEVICE_TYPE_DHW201 = 0;
   */
  DHW201 = 0,

  /**
   * LCD-200 (Comissioning tool.)
   *
   * @generated from enum value: DEVICE_TYPE_LCD = 4;
   */
  LCD = 4,

  /**
   * Room thermostat wired
   *
   * @generated from enum value: DEVICE_TYPE_RT210 = 5;
   */
  RT210 = 5,

  /**
   * Room thermostat wireless
   *
   * @generated from enum value: DEVICE_TYPE_RT250 = 6;
   */
  RT250 = 6,

  /**
   * Room sensor wired (only sensing Temp+Humidity)
   *
   * @generated from enum value: DEVICE_TYPE_RS211 = 7;
   */
  RS211 = 7,

  /**
   * Room sensor wireless
   *
   * @generated from enum value: DEVICE_TYPE_RS251 = 8;
   */
  RS251 = 8,

  /**
   * Room thermostat wireless + infrared floor sensor
   *
   * @generated from enum value: DEVICE_TYPE_RT250IR = 9;
   */
  RT250IR = 9,

  /**
   * Extension unit with 8 additional UFH connectors
   *
   * @generated from enum value: DEVICE_TYPE_EU208A = 10;
   */
  EU208A = 10,

  /**
   * Extension unit with 6 additional Voltage Free Relays
   *
   * @generated from enum value: DEVICE_TYPE_EU206VFR = 11;
   */
  EU206VFR = 11,

  /**
   * Outdoor Temperature sensor Wireless
   *
   * @generated from enum value: DEVICE_TYPE_ET250 = 12;
   */
  ET250 = 12,

  /**
   * Outdoor Temperature sensor wired
   *
   * @generated from enum value: DEVICE_TYPE_ET210 = 13;
   */
  ET210 = 13,

  /**
   * Radiator thermostat wireless (Smart Radiator thermostat)
   *
   * @generated from enum value: DEVICE_TYPE_VH250 = 14;
   */
  VH250 = 14,

  /**
   * Not used, placeholder for wired radiator thermostat project
   *
   * @generated from enum value: DEVICE_TYPE_VH210 = 15;
   */
  VH210 = 15,

  /**
   * Room thermostat wired with CO2 sensor
   *
   * @generated from enum value: DEVICE_TYPE_RT212 = 16;
   */
  RT212 = 16,

  /**
   * Room sensor wired with CO2 sensor
   *
   * @generated from enum value: DEVICE_TYPE_RS213 = 20;
   */
  RS213 = 20,

  /**
   * @generated from enum value: DEVICE_TYPE_CR250 = 24;
   */
  CR250 = 24,

  /**
   * @generated from enum value: DEVICE_TYPE_PR252 = 26;
   */
  PR252 = 26,

  /**
   * Room thermostat wireless with CO2 sensor
   *
   * @generated from enum value: DEVICE_TYPE_RT252 = 28;
   */
  RT252 = 28,

  /**
   * Room sensor wireless with CO2
   *
   * @generated from enum value: DEVICE_TYPE_RT253 = 32;
   */
  RT253 = 32,

  /**
   * Calefa-II Simple = without Display (Cheapest variant)
   *
   * @generated from enum value: DEVICE_TYPE_DHW211_S = 192;
   */
  DHW211_S = 192,

  /**
   * Calefa-II Base model
   *
   * @generated from enum value: DEVICE_TYPE_DHW211 = 195;
   */
  DHW211 = 195,

  /**
   * Calefa-II Double Heat Exchanger (V is something danish for separated heating and tap-water)
   *
   * @generated from enum value: DEVICE_TYPE_DHW211_V = 198;
   */
  DHW211_V = 198,

  /**
   * Calefa-II with ITC controller
   *
   * @generated from enum value: DEVICE_TYPE_DHW212_ITC = 201;
   */
  DHW212_ITC = 201,

  /**
   * Calefa-II with ITC Controller + Double heat exchanger
   *
   * @generated from enum value: DEVICE_TYPE_DHW212_ITC_V = 204;
   */
  DHW212_ITC_V = 204,

  /**
   * Calefa-II with Heat Control
   *
   * @generated from enum value: DEVICE_TYPE_DHW212_HC = 207;
   */
  DHW212_HC = 207,

  /**
   * Calefa-II with Heat Control and double Heat Exchanger
   *
   * @generated from enum value: DEVICE_TYPE_DHW212_HC_V = 210;
   */
  DHW212_HC_V = 210,

  /**
   * CCU 208 Controller (Sentio main device)
   *
   * @generated from enum value: DEVICE_TYPE_CCU208 = 224;
   */
  CCU208 = 224,

  /**
   * Mobile App (used as a peripheral on the bus)
   *
   * @generated from enum value: DEVICE_TYPE_PC_APP = 255;
   */
  PC_APP = 255,
}

/**
 * Describes the enum wavin.sentio.v1.DeviceType.
 */
export const DeviceTypeSchema: GenEnum<DeviceType> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 4);

/**
 * Value ID
 *
 * @generated from enum wavin.sentio.v1.VID
 */
export enum VID {
  /**
   * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
   *
   * @generated from enum value: VID_INVALID = 0;
   */
  VID_INVALID = 0,

  /**
   * Common (all objects)
   *
   * @generated from enum value: VID_OBJECT_NAME = 32912;
   */
  VID_OBJECT_NAME = 32912,

  /**
   * @generated from enum value: VID_OBJECT_INFO = 32925;
   */
  VID_OBJECT_INFO = 32925,

  /**
   * @generated from enum value: VID_OBJECT_STATUS = 33849;
   */
  VID_OBJECT_STATUS = 33849,

  /**
   * @generated from enum value: VID_OBJECT_RUNTIME_VALUES = 32927;
   */
  VID_OBJECT_RUNTIME_VALUES = 32927,

  /**
   * @generated from enum value: VID_OBJECT_SERVICE_VALUES = 32939;
   */
  VID_OBJECT_SERVICE_VALUES = 32939,

  /**
   * @generated from enum value: VID_OBJECT_PERIPHERAL_LIST = 32942;
   */
  VID_OBJECT_PERIPHERAL_LIST = 32942,

  /**
   * Common Indoor
   *
   * @generated from enum value: VID_INDOOR_AIR_TEMPERATURE = 12;
   */
  VID_INDOOR_AIR_TEMPERATURE = 12,

  /**
   * @generated from enum value: VID_INDOOR_FLOOR_TEMPERATURE = 13;
   */
  VID_INDOOR_FLOOR_TEMPERATURE = 13,

  /**
   * @generated from enum value: VID_INDOOR_HUMIDITY = 2;
   */
  VID_INDOOR_HUMIDITY = 2,

  /**
   * @generated from enum value: VID_INDOOR_DEW_POINT = 75;
   */
  VID_INDOOR_DEW_POINT = 75,

  /**
   * @generated from enum value: VID_INDOOR_VALUES_CO2_LEVEL = 3;
   */
  VID_INDOOR_VALUES_CO2_LEVEL = 3,

  /**
   * @generated from enum value: VID_INDOOR_VALUES_VOC_LEVEL = 4;
   */
  VID_INDOOR_VALUES_VOC_LEVEL = 4,

  /**
   * Common Outdoor
   *
   * @generated from enum value: VID_OUTDOOR_TEMPERATURE = 54;
   */
  VID_OUTDOOR_TEMPERATURE = 54,

  /**
   * @generated from enum value: VID_OUTDOOR_TEMPERATURE_FILTERED = 40;
   */
  VID_OUTDOOR_TEMPERATURE_FILTERED = 40,

  /**
   * @generated from enum value: VID_OUTDOOR_TEMPERATURE_AVERAGE = 94;
   */
  VID_OUTDOOR_TEMPERATURE_AVERAGE = 94,

  /**
   * Common Domestic Hot/Cold Water Distribution
   *
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_TEMPERATURE = 17;
   */
  VID_DOMESTIC_HOT_WATER_TEMPERATURE = 17,

  /**
   * @generated from enum value: VID_DOMESTIC_COLD_WATER_TEMPERATURE = 20;
   */
  VID_DOMESTIC_COLD_WATER_TEMPERATURE = 20,

  /**
   * @generated from enum value: VID_DOMESTIC_COLD_WATER_FLOW = 19;
   */
  VID_DOMESTIC_COLD_WATER_FLOW = 19,

  /**
   * Common ventilation
   *
   * @generated from enum value: VID_VENTILATION_SOURCE_DEMAND = 240;
   */
  VID_VENTILATION_SOURCE_DEMAND = 240,

  /**
   * @generated from enum value: VID_VENTILATION_SOURCE_STATUS = 241;
   */
  VID_VENTILATION_SOURCE_STATUS = 241,

  /**
   * @generated from enum value: VID_VENTILATION_STATE = 245;
   */
  VID_VENTILATION_STATE = 245,

  /**
   * @generated from enum value: VID_VENTILATION_CONSUMER_LIST = 33990;
   */
  VID_VENTILATION_CONSUMER_LIST = 33990,

  /**
   * @generated from enum value: VID_VENTILATION_SUPPLIER_OID = 33991;
   */
  VID_VENTILATION_SUPPLIER_OID = 33991,

  /**
   * Common drying
   *
   * @generated from enum value: VID_DRYING_STATE = 153;
   */
  VID_DRYING_STATE = 153,

  /**
   * Location Object
   *
   * @generated from enum value: VID_LOCATION_NAME = 32768;
   */
  VID_LOCATION_NAME = 32768,

  /**
   * @generated from enum value: VID_LOCATION_LANGUAGE = 32862;
   */
  VID_LOCATION_LANGUAGE = 32862,

  /**
   * @generated from enum value: VID_LOCATION_TIMEZONE = 32879;
   */
  VID_LOCATION_TIMEZONE = 32879,

  /**
   * @generated from enum value: VID_LOCATION_TIMEZONE_OFFSET = 32884;
   */
  VID_LOCATION_TIMEZONE_OFFSET = 32884,

  /**
   * @generated from enum value: VID_LOCATION_TIMEZONE_DST_ENABLED = 32885;
   */
  VID_LOCATION_TIMEZONE_DST_ENABLED = 32885,

  /**
   * @generated from enum value: VID_LOCATION_TIMEZONE_DST_UPCOMING = 275;
   */
  VID_LOCATION_TIMEZONE_DST_UPCOMING = 275,

  /**
   * @generated from enum value: VID_LOCATION_LOCAL_TIME_OFFSET = 46;
   */
  VID_LOCATION_LOCAL_TIME_OFFSET = 46,

  /**
   * @generated from enum value: VID_LOCATION_COUNTRY = 33926;
   */
  VID_LOCATION_COUNTRY = 33926,

  /**
   * @generated from enum value: VID_LOCATION_CONTROL_UNIT_OID = 32988;
   */
  VID_LOCATION_CONTROL_UNIT_OID = 32988,

  /**
   * @generated from enum value: VID_LOCATION_VACATION = 32901;
   */
  VID_LOCATION_VACATION = 32901,

  /**
   * @generated from enum value: VID_LOCATION_VACATION_END_TIME = 32902;
   */
  VID_LOCATION_VACATION_END_TIME = 32902,

  /**
   * @generated from enum value: VID_LOCATION_STANDBY = 32903;
   */
  VID_LOCATION_STANDBY = 32903,

  /**
   * @generated from enum value: VID_LOCATION_HC_MODE = 32829;
   */
  VID_LOCATION_HC_MODE = 32829,

  /**
   * @generated from enum value: VID_LOCATION_HC_MODE_SWITCHING = 32886;
   */
  VID_LOCATION_HC_MODE_SWITCHING = 32886,

  /**
   * @generated from enum value: VID_LOCATION_HC_MODE_PRIORITY = 34015;
   */
  VID_LOCATION_HC_MODE_PRIORITY = 34015,

  /**
   * @generated from enum value: VID_LOCATION_HC_MODE_BMS_OVERRIDE = 34016;
   */
  VID_LOCATION_HC_MODE_BMS_OVERRIDE = 34016,

  /**
   * @generated from enum value: VID_LOCATION_INSTALLER_PASSWORD = 33062;
   */
  VID_LOCATION_INSTALLER_PASSWORD = 33062,

  /**
   * permanent password
   *
   * @generated from enum value: VID_LOCATION_SERVICE_KEY = 126;
   */
  VID_LOCATION_SERVICE_KEY = 126,

  /**
   * @generated from enum value: VID_LOCATION_SERVICE_KEY_ACCESS_ALLOWED = 33076;
   */
  VID_LOCATION_SERVICE_KEY_ACCESS_ALLOWED = 33076,

  /**
   * @generated from enum value: VID_LOCATION_GENERATE_TEMPORARY_PASSWORD = 250;
   */
  VID_LOCATION_GENERATE_TEMPORARY_PASSWORD = 250,

  /**
   * @generated from enum value: VID_LOCATION_TEMPORARY_PASSWORD = 253;
   */
  VID_LOCATION_TEMPORARY_PASSWORD = 253,

  /**
   * @generated from enum value: VID_LOCATION_TEMPORARY_PASSWORD_EXPIRATION = 254;
   */
  VID_LOCATION_TEMPORARY_PASSWORD_EXPIRATION = 254,

  /**
   * @generated from enum value: VID_LOCATION_USER_ENROLLMENT_ENABLED = 331;
   */
  VID_LOCATION_USER_ENROLLMENT_ENABLED = 331,

  /**
   * @generated from enum value: VID_LOCATION_ALARM_HEAT_PUMP_FAULT = 16413;
   */
  VID_LOCATION_ALARM_HEAT_PUMP_FAULT = 16413,

  /**
   * @generated from enum value: VID_LOCATION_ALARM_EXTERNAL_DEVICE_FAULT = 16452;
   */
  VID_LOCATION_ALARM_EXTERNAL_DEVICE_FAULT = 16452,

  /**
   * 0 = Production endpoint, 1 = Develop endpoint with test AES key
   *
   * @generated from enum value: VID_LOCATION_TESTING_ENDPOINT = 34099;
   */
  VID_LOCATION_TESTING_ENDPOINT = 34099,

  /**
   * Default 500 ms, minimum 0 ms and maximum 5000ms
   *
   * @generated from enum value: VID_LOCATION_LONG_POLL_TIME = 342;
   */
  VID_LOCATION_LONG_POLL_TIME = 342,

  /**
   * Device Object
   *
   * @generated from enum value: VID_DEVICE_NAME = 32779;
   */
  VID_DEVICE_NAME = 32779,

  /**
   * @generated from enum value: VID_DEVICE_STATE = 47;
   */
  VID_DEVICE_STATE = 47,

  /**
   * @generated from enum value: VID_DEVICE_OBJECT_LIST = 32944;
   */
  VID_DEVICE_OBJECT_LIST = 32944,

  /**
   * @generated from enum value: VID_DEVICE_SERIAL = 32780;
   */
  VID_DEVICE_SERIAL = 32780,

  /**
   * @generated from enum value: VID_DEVICE_SERIAL_PREFIX = 32991;
   */
  VID_DEVICE_SERIAL_PREFIX = 32991,

  /**
   * @generated from enum value: VID_DEVICE_BOOTLOADER_CODE = 32992;
   */
  VID_DEVICE_BOOTLOADER_CODE = 32992,

  /**
   * @generated from enum value: VID_DEVICE_BOOTLOADER_VERSION = 32993;
   */
  VID_DEVICE_BOOTLOADER_VERSION = 32993,

  /**
   * @generated from enum value: VID_DEVICE_BOOTLOADER_VERSION_MINOR = 32994;
   */
  VID_DEVICE_BOOTLOADER_VERSION_MINOR = 32994,

  /**
   * @generated from enum value: VID_DEVICE_HARDWARE_NAME = 32995;
   */
  VID_DEVICE_HARDWARE_NAME = 32995,

  /**
   * @generated from enum value: VID_DEVICE_HARDWARE_VERSION = 32782;
   */
  VID_DEVICE_HARDWARE_VERSION = 32782,

  /**
   * @generated from enum value: VID_DEVICE_SOFTWARE_NAME = 32996;
   */
  VID_DEVICE_SOFTWARE_NAME = 32996,

  /**
   * @generated from enum value: VID_DEVICE_SOFTWARE_VARIANT = 32997;
   */
  VID_DEVICE_SOFTWARE_VARIANT = 32997,

  /**
   * @generated from enum value: VID_DEVICE_SOFTWARE_VERSION = 32781;
   */
  VID_DEVICE_SOFTWARE_VERSION = 32781,

  /**
   * @generated from enum value: VID_DEVICE_SOFTWARE_VERSION_MINOR = 32926;
   */
  VID_DEVICE_SOFTWARE_VERSION_MINOR = 32926,

  /**
   * @generated from enum value: VID_DEVICE_SOFTWARE_VERSION_BRANCH = 33077;
   */
  VID_DEVICE_SOFTWARE_VERSION_BRANCH = 33077,

  /**
   * @generated from enum value: VID_DEVICE_CONFIG_VERSION = 33931;
   */
  VID_DEVICE_CONFIG_VERSION = 33931,

  /**
   * @generated from enum value: VID_DEVICE_UPDATE_CONTROL = 32871;
   */
  VID_DEVICE_UPDATE_CONTROL = 32871,

  /**
   * @generated from enum value: VID_DEVICE_ALARM_LOW_BATTERY = 16387;
   */
  VID_DEVICE_ALARM_LOW_BATTERY = 16387,

  /**
   * @generated from enum value: VID_DEVICE_UPDATE_PRESET = 332;
   */
  VID_DEVICE_UPDATE_PRESET = 332,

  /**
   * @generated from enum value: VID_DEVICE_UPTIME = 308;
   */
  VID_DEVICE_UPTIME = 308,

  /**
   * Room Object
   *
   * @generated from enum value: VID_ROOM_TEMP_DESIRED = 29;
   */
  VID_ROOM_TEMP_DESIRED = 29,

  /**
   * @generated from enum value: VID_ROOM_MODE = 32772;
   */
  VID_ROOM_MODE = 32772,

  /**
   * @generated from enum value: VID_ROOM_THERMOSTAT_ACCESS_LEVEL = 32776;
   */
  VID_ROOM_THERMOSTAT_ACCESS_LEVEL = 32776,

  /**
   * @generated from enum value: VID_ROOM_WEEK_SCHEDULE = 32835;
   */
  VID_ROOM_WEEK_SCHEDULE = 32835,

  /**
   * @generated from enum value: VID_ROOM_ALLOW_COOLING = 33848;
   */
  VID_ROOM_ALLOW_COOLING = 33848,

  /**
   * @generated from enum value: VID_ROOM_ALLOW_VACATION_AWAY = 32900;
   */
  VID_ROOM_ALLOW_VACATION_AWAY = 32900,

  /**
   * @generated from enum value: VID_ROOM_ALARM_PERIPHERAL_UNREACHABLE = 16400;
   */
  VID_ROOM_ALARM_PERIPHERAL_UNREACHABLE = 16400,

  /**
   * @generated from enum value: VID_ROOM_ALARM_FROST_PROTECTION = 16427;
   */
  VID_ROOM_ALARM_FROST_PROTECTION = 16427,

  /**
   * @generated from enum value: VID_ROOM_ALARM_BATTERY_OPEN = 16450;
   */
  VID_ROOM_ALARM_BATTERY_OPEN = 16450,

  /**
   * @generated from enum value: VID_ROOM_ALARM_BADLY_INSTALLED = 16451;
   */
  VID_ROOM_ALARM_BADLY_INSTALLED = 16451,

  /**
   * @generated from enum value: VID_ROOM_ALARM_STICKING_VALVE = 16460;
   */
  VID_ROOM_ALARM_STICKING_VALVE = 16460,

  /**
   * @generated from enum value: VID_ROOM_ALARM_GENERAL_PROBLEM = 16386;
   */
  VID_ROOM_ALARM_GENERAL_PROBLEM = 16386,

  /**
   * Room Temperature Controller
   *
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_STANDBY = 32783;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_STANDBY = 32783,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HC_MODE = 32859;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HC_MODE = 32859,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_STATE = 27;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_STATE = 27,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_BLOCKING = 28;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_BLOCKING = 28,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_ALARM_LOW = 32784;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_ALARM_LOW = 32784,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_ALARM_HIGH = 32785;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_ALARM_HIGH = 32785,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_TEMP_ALARM_LOW = 33011;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_TEMP_ALARM_LOW = 33011,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_TEMP_ALARM_HIGH = 33012;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_TEMP_ALARM_HIGH = 33012,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_REGULATED_VALUE_SRC = 32788;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_REGULATED_VALUE_SRC = 32788,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SPAN_MIN = 32792;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SPAN_MIN = 32792,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SPAN_MAX = 32793;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SPAN_MAX = 32793,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_ECO = 32795;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_ECO = 32795,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_COMFORT = 32796;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_COMFORT = 32796,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_EXTRA_COMFORT = 32797;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_EXTRA_COMFORT = 32797,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_VACATION = 32799;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_VACATION = 32799,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_STANDBY = 32801;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEAT_SET_STANDBY = 32801,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SPAN_MIN = 32811;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SPAN_MIN = 32811,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SPAN_MAX = 32812;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SPAN_MAX = 32812,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_ECO = 32814;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_ECO = 32814,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_COMFORT = 32815;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_COMFORT = 32815,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_EXTRA_COMFORT = 32816;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_EXTRA_COMFORT = 32816,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_VACATION = 32818;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_VACATION = 32818,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_STANDBY = 32898;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOL_SET_STANDBY = 32898,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_LOW_TEMP = 16389;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_LOW_TEMP = 16389,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_HIGH_TEMP = 16390;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_HIGH_TEMP = 16390,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_LOW_FLOOR_TEMP = 16401;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_LOW_FLOOR_TEMP = 16401,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_HIGH_FLOOR_TEMP = 16402;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_ALARM_HIGH_FLOOR_TEMP = 16402,

  /**
   * Room humidity controller
   *
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_ENABLED = 32899;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_ENABLED = 32899,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SPAN_MIN = 34032;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SPAN_MIN = 34032,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SPAN_MAX = 34033;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SPAN_MAX = 34033,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SETPOINT_HEAT = 33851;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SETPOINT_HEAT = 33851,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SETPOINT_COOL = 33843;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_SETPOINT_COOL = 33843,

  /**
   * Update Controller Object
   *
   * @generated from enum value: VID_UPDATE_CONTROLLER_PROGRESS_DEVICE_IDX = 109;
   */
  VID_UPDATE_CONTROLLER_PROGRESS_DEVICE_IDX = 109,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_PROGRESS_DEVICE_PERCENT = 110;
   */
  VID_UPDATE_CONTROLLER_PROGRESS_DEVICE_PERCENT = 110,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_ONLINE_DEVICES = 112;
   */
  VID_UPDATE_CONTROLLER_ONLINE_DEVICES = 112,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_OFFLINE_DEVICES = 113;
   */
  VID_UPDATE_CONTROLLER_OFFLINE_DEVICES = 113,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_MODE = 33066;
   */
  VID_UPDATE_CONTROLLER_UPDATE_MODE = 33066,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_STATE = 33067;
   */
  VID_UPDATE_CONTROLLER_UPDATE_STATE = 33067,

  /**
   * semantic version: 1.0.0
   *
   * @generated from enum value: VID_UPDATE_CONTROLLER_STORED_FIRMWARE_PACKAGE_VERSION = 33070;
   */
  VID_UPDATE_CONTROLLER_STORED_FIRMWARE_PACKAGE_VERSION = 33070,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_DEVICES_TO_UPDATE = 33071;
   */
  VID_UPDATE_CONTROLLER_DEVICES_TO_UPDATE = 33071,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_ALL_TIME = 33072;
   */
  VID_UPDATE_CONTROLLER_UPDATE_ALL_TIME = 33072,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_CCU_TIME = 33073;
   */
  VID_UPDATE_CONTROLLER_UPDATE_CCU_TIME = 33073,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_CCU_TIMEOUT = 33074;
   */
  VID_UPDATE_CONTROLLER_UPDATE_CCU_TIMEOUT = 33074,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_INSTALLED_FIRMWARE_PACKAGE_VERSION = 33075;
   */
  VID_UPDATE_CONTROLLER_INSTALLED_FIRMWARE_PACKAGE_VERSION = 33075,

  /**
   * semantic version: 1.0.0
   *
   * @generated from enum value: VID_UPDATE_CONTROLLER_PACKAGE_DOWNLOAD_REQUEST = 330;
   */
  VID_UPDATE_CONTROLLER_PACKAGE_DOWNLOAD_REQUEST = 330,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_PACKAGE_DOWNLOAD_STATE = 329;
   */
  VID_UPDATE_CONTROLLER_PACKAGE_DOWNLOAD_STATE = 329,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATE_START_REQUEST = 328;
   */
  VID_UPDATE_CONTROLLER_UPDATE_START_REQUEST = 328,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_UPDATING_DEVICE_OID = 316;
   */
  VID_UPDATE_CONTROLLER_UPDATING_DEVICE_OID = 316,

  /**
   * Input Object
   *
   * @generated from enum value: VID_INPUT_VALUE = 74;
   */
  VID_INPUT_VALUE = 74,

  /**
   * Output Object
   *
   * @generated from enum value: VID_OUTPUT_OUTPUT_VALUE = 76;
   */
  VID_OUTPUT_OUTPUT_VALUE = 76,

  /**
   * @generated from enum value: VID_OUTPUT_FUNCTION = 32999;
   */
  VID_OUTPUT_FUNCTION = 32999,

  /**
   * @generated from enum value: VID_OUTPUT_MANUAL_VALUE = 33008;
   */
  VID_OUTPUT_MANUAL_VALUE = 33008,

  /**
   * DHW Calefa Controller
   *
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_TEMP_SPAN_MIN = 32914;
   */
  VID_DHW_CALEFA_CONTROLLER_TEMP_SPAN_MIN = 32914,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_TEMP_SPAN_MAX = 32915;
   */
  VID_DHW_CALEFA_CONTROLLER_TEMP_SPAN_MAX = 32915,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_TEMP_SET = 32916;
   */
  VID_DHW_CALEFA_CONTROLLER_TEMP_SET = 32916,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_CRITICAL_LOW_PRESSURE = 16435;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_CRITICAL_LOW_PRESSURE = 16435,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_HIGH_PRESSURE = 16436;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_HIGH_PRESSURE = 16436,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_LOW_PRESSURE = 16437;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_LOW_PRESSURE = 16437,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_LOW_ENERGY = 16393;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_LOW_ENERGY = 16393,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_HIGH_TEMPERATURE = 16394;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_HIGH_TEMPERATURE = 16394,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_DHI_SENSOR_FAILURE = 16418;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_DHI_SENSOR_FAILURE = 16418,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_DHO_SENSOR_FAILURE = 16419;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_DHO_SENSOR_FAILURE = 16419,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_DHW_SENSOR_FAILURE = 16420;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_DHW_SENSOR_FAILURE = 16420,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_DCW_SENSOR_FAILURE = 16421;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_DCW_SENSOR_FAILURE = 16421,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_MOTOR_FAILURE = 16422;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_MOTOR_FAILURE = 16422,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_PRESSURE_SENSOR_FAILURE = 16499;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_PRESSURE_SENSOR_FAILURE = 16499,

  /**
   * @generated from enum value: VID_DHW_CALEFA_CONTROLLER_ALARM_FLOW_SENSOR_FAILURE = 16502;
   */
  VID_DHW_CALEFA_CONTROLLER_ALARM_FLOW_SENSOR_FAILURE = 16502,

  /**
   * DHW Circulation Controller
   *
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_ALARM_CIRCULATION_SENSOR_FAILURE = 16395;
   */
  VID_DHW_CIRCULATION_CONTROLLER_ALARM_CIRCULATION_SENSOR_FAILURE = 16395,

  /**
   * DHW Heating Controller
   *
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_ALARM_HEATING_MOTOR_FAILURE = 16500;
   */
  VID_DHW_HEATING_CONTROLLER_ALARM_HEATING_MOTOR_FAILURE = 16500,

  /**
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_ALARM_HEATING_MOTOR_STUCK = 16510;
   */
  VID_DHW_HEATING_CONTROLLER_ALARM_HEATING_MOTOR_STUCK = 16510,

  /**
   * Dryer
   *
   * @generated from enum value: VID_DRYER_ALARM_GENERAL_FAULT = 50192;
   */
  VID_DRYER_ALARM_GENERAL_FAULT = 50192,

  /**
   * @generated from enum value: VID_DRYER_ALARM_WARNING_MAINTENANCE = 50193;
   */
  VID_DRYER_ALARM_WARNING_MAINTENANCE = 50193,

  /**
   * External Device
   *
   * @generated from enum value: VID_EXTERNAL_DEVICE_ALARM_CONNECTION_LOST = 16447;
   */
  VID_EXTERNAL_DEVICE_ALARM_CONNECTION_LOST = 16447,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_ALARM_DEVICE_SPECIFIC_ERROR = 16494;
   */
  VID_EXTERNAL_DEVICE_ALARM_DEVICE_SPECIFIC_ERROR = 16494,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_ALARM_DEVICE_SPECIFIC_WARNING = 16495;
   */
  VID_EXTERNAL_DEVICE_ALARM_DEVICE_SPECIFIC_WARNING = 16495,

  /**
   * External Device - MVDI
   *
   * @generated from enum value: VID_EXTERNAL_DEVICE_MVDI_ALARM_FILTER_REPLACEMENT_NEEDED = 16449;
   */
  VID_EXTERNAL_DEVICE_MVDI_ALARM_FILTER_REPLACEMENT_NEEDED = 16449,

  /**
   * External Device - mechanical ventilation
   *
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_FEATURES = 257;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_FEATURES = 257,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_FEATURES_ENABLED = 280;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_FEATURES_ENABLED = 280,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SCHEDULER_ENABLED = 33963;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SCHEDULER_ENABLED = 33963,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MANUAL_LEVEL = 33965;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MANUAL_LEVEL = 33965,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MODE_OVERRIDE = 33989;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MODE_OVERRIDE = 33989,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_STATE = 238;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_STATE = 238,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_REQUEST = 239;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_REQUEST = 239,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_END_TIME = 296;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_MAINTENANCE_END_TIME = 296,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LIFETIME = 33830;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LIFETIME = 33830,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LIFETIME_USED = 33831;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LIFETIME_USED = 33831,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LAST_CHANGED = 33855;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_AIR_FILTER_LAST_CHANGED = 33855,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALARM_RESTART = 16497;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALARM_RESTART = 16497,

  /**
   * Unmapped broker values
   *
   * @generated from enum value: VID_AGGREGATED_MVDI_PUMP_DEMAND = 163;
   */
  VID_AGGREGATED_MVDI_PUMP_DEMAND = 163,

  /**
   * @generated from enum value: VID_AIR_CONDITIONING_DISTRIBUTION_BLOCKING = 89;
   */
  VID_AIR_CONDITIONING_DISTRIBUTION_BLOCKING = 89,

  /**
   * @generated from enum value: VID_AIR_CONDITIONING_DISTRIBUTION_CONSUMER_LIST = 33037;
   */
  VID_AIR_CONDITIONING_DISTRIBUTION_CONSUMER_LIST = 33037,

  /**
   * @generated from enum value: VID_AIR_CONDITIONING_DISTRIBUTION_REQUIRED_LEVEL = 87;
   */
  VID_AIR_CONDITIONING_DISTRIBUTION_REQUIRED_LEVEL = 87,

  /**
   * @generated from enum value: VID_AIR_CONDITIONING_DISTRIBUTION_SOURCE_SUPPLIER_OID = 33038;
   */
  VID_AIR_CONDITIONING_DISTRIBUTION_SOURCE_SUPPLIER_OID = 33038,

  /**
   * @generated from enum value: VID_ANALOG_OUTPUT_HIGH_LEVEL_VOLTAGE = 33015;
   */
  VID_ANALOG_OUTPUT_HIGH_LEVEL_VOLTAGE = 33015,

  /**
   * @generated from enum value: VID_ANALOG_OUTPUT_LOW_LEVEL_VOLTAGE = 33016;
   */
  VID_ANALOG_OUTPUT_LOW_LEVEL_VOLTAGE = 33016,

  /**
   * @generated from enum value: VID_ANALOG_OUTPUT_NO_DEMAND_VOLTAGE = 33039;
   */
  VID_ANALOG_OUTPUT_NO_DEMAND_VOLTAGE = 33039,

  /**
   * @generated from enum value: VID_BROKER_DEBUG_WRITE_THROUGH_IN = 306;
   */
  VID_BROKER_DEBUG_WRITE_THROUGH_IN = 306,

  /**
   * @generated from enum value: VID_BROKER_DEBUG_WRITE_THROUGH_RESULT = 307;
   */
  VID_BROKER_DEBUG_WRITE_THROUGH_RESULT = 307,

  /**
   * @generated from enum value: VID_BROKER_DEBUG_WRITE_THROUGH_TARGET = 34076;
   */
  VID_BROKER_DEBUG_WRITE_THROUGH_TARGET = 34076,

  /**
   * @generated from enum value: VID_BROKER_FLASH_REWRITE_COUNT = 237;
   */
  VID_BROKER_FLASH_REWRITE_COUNT = 237,

  /**
   * @generated from enum value: VID_BROKER_FLASH_STORE_TRIGGER_TIMESTAMP = 305;
   */
  VID_BROKER_FLASH_STORE_TRIGGER_TIMESTAMP = 305,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_CLIENTS = 73;
   */
  VID_BROKER_USED_BROKER_CLIENTS = 73,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_INDEX_QUEUE_PRIORITY_SLOTS = 71;
   */
  VID_BROKER_USED_BROKER_INDEX_QUEUE_PRIORITY_SLOTS = 71,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_INDEX_QUEUE_SLOTS = 70;
   */
  VID_BROKER_USED_BROKER_INDEX_QUEUE_SLOTS = 70,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_PT_LINES = 68;
   */
  VID_BROKER_USED_BROKER_PT_LINES = 68,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_PT_MEMBLOCKS = 69;
   */
  VID_BROKER_USED_BROKER_PT_MEMBLOCKS = 69,

  /**
   * @generated from enum value: VID_BROKER_USED_BROKER_SUBSCRIPTIONS = 72;
   */
  VID_BROKER_USED_BROKER_SUBSCRIPTIONS = 72,

  /**
   * @generated from enum value: VID_CLOUD_BACKEND_PACKET_SENT_AVERAGE = 247;
   */
  VID_CLOUD_BACKEND_PACKET_SENT_AVERAGE = 247,

  /**
   * @generated from enum value: VID_CLOUD_BACKEND_PACKET_SENT_STATISTICS = 246;
   */
  VID_CLOUD_BACKEND_PACKET_SENT_STATISTICS = 246,

  /**
   * @generated from enum value: VID_CLOUD_CLOUD_ADDRESS_OVERRIDE = 33102;
   */
  VID_CLOUD_CLOUD_ADDRESS_OVERRIDE = 33102,

  /**
   * @generated from enum value: VID_CLOUD_CLOUD_KEY_OVERRIDE = 263;
   */
  VID_CLOUD_CLOUD_KEY_OVERRIDE = 263,

  /**
   * @generated from enum value: VID_CLOUD_ROOM_ALARM_PERIPHERAL_UNREACHABLE_FILTERED = 16467;
   */
  VID_CLOUD_ROOM_ALARM_PERIPHERAL_UNREACHABLE_FILTERED = 16467,

  /**
   * @generated from enum value: VID_CLOUD_ROOM_ERROR_INCOMPATIBLE_PERIPHERAL = 16466;
   */
  VID_CLOUD_ROOM_ERROR_INCOMPATIBLE_PERIPHERAL = 16466,

  /**
   * @generated from enum value: VID_CO2_THRESHOLD = 34109;
   */
  VID_CO2_THRESHOLD = 34109,

  /**
   * @generated from enum value: VID_CO2_THRESHOLD_HIGH = 34081;
   */
  VID_CO2_THRESHOLD_HIGH = 34081,

  /**
   * @generated from enum value: VID_CO2_THRESHOLD_LOW = 34079;
   */
  VID_CO2_THRESHOLD_LOW = 34079,

  /**
   * @generated from enum value: VID_CO2_THRESHOLD_MEDIUM = 34080;
   */
  VID_CO2_THRESHOLD_MEDIUM = 34080,

  /**
   * @generated from enum value: VID_COMMON_DEBUG_CHANNEL = 95;
   */
  VID_COMMON_DEBUG_CHANNEL = 95,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_AIR_FILTER_LAST_CHANGE = 49201;
   */
  VID_DEVICE_DRYER_AIR_FILTER_LAST_CHANGE = 49201,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_AIR_FILTER_LIFETIME_HOURS = 49176;
   */
  VID_DEVICE_DRYER_AIR_FILTER_LIFETIME_HOURS = 49176,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_DEVICE_STATE = 49178;
   */
  VID_DEVICE_DRYER_DEVICE_STATE = 49178,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_FEATURES = 49177;
   */
  VID_DEVICE_DRYER_FEATURES = 49177,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_ID = 49175;
   */
  VID_DEVICE_DRYER_ID = 49175,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_MAINTENANCE_REQUEST = 49199;
   */
  VID_DEVICE_DRYER_MAINTENANCE_REQUEST = 49199,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_MAINTENANCE_STATE = 49198;
   */
  VID_DEVICE_DRYER_MAINTENANCE_STATE = 49198,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_MAINTENANCE_STATE_TRANSITION_TIME = 49200;
   */
  VID_DEVICE_DRYER_MAINTENANCE_STATE_TRANSITION_TIME = 49200,

  /**
   * @generated from enum value: VID_DEVICE_DRYER_NAME = 51241;
   */
  VID_DEVICE_DRYER_NAME = 51241,

  /**
   * @generated from enum value: VID_DEVICE_BASE_TEMPERATURE = 161;
   */
  VID_DEVICE_BASE_TEMPERATURE = 161,

  /**
   * @generated from enum value: VID_DEVICE_BATTERY_LEVEL = 44;
   */
  VID_DEVICE_BATTERY_LEVEL = 44,

  /**
   * @generated from enum value: VID_DEVICE_CLIENT_BROKER_ROLE = 302;
   */
  VID_DEVICE_CLIENT_BROKER_ROLE = 302,

  /**
   * @generated from enum value: VID_DEVICE_COMUNICATION_RELIABILITY_TEST_DATA = 119;
   */
  VID_DEVICE_COMUNICATION_RELIABILITY_TEST_DATA = 119,

  /**
   * @generated from enum value: VID_DEVICE_DEBUG_GROUP_MASK = 33823;
   */
  VID_DEVICE_DEBUG_GROUP_MASK = 33823,

  /**
   * @generated from enum value: VID_DEVICE_DEBUG_MODIFIABLE_OVI_LIST = 34077;
   */
  VID_DEVICE_DEBUG_MODIFIABLE_OVI_LIST = 34077,

  /**
   * @generated from enum value: VID_DEVICE_DEVICE_DESCRIPTOR_VERSION = 34012;
   */
  VID_DEVICE_DEVICE_DESCRIPTOR_VERSION = 34012,

  /**
   * @generated from enum value: VID_DEVICE_DEVICE_METADATA = 33022;
   */
  VID_DEVICE_DEVICE_METADATA = 33022,

  /**
   * @generated from enum value: VID_DEVICE_DEVICE_SHUTDOWN = 102;
   */
  VID_DEVICE_DEVICE_SHUTDOWN = 102,

  /**
   * @generated from enum value: VID_DEVICE_DEVICE_SHUTDOWN_TIME = 258;
   */
  VID_DEVICE_DEVICE_SHUTDOWN_TIME = 258,

  /**
   * @generated from enum value: VID_DEVICE_ERROR_EXTERNAL_SENSOR_FAIL = 16433;
   */
  VID_DEVICE_ERROR_EXTERNAL_SENSOR_FAIL = 16433,

  /**
   * @generated from enum value: VID_DEVICE_ERROR_INCOMPATIBLE_PERIPHERAL = 16465;
   */
  VID_DEVICE_ERROR_INCOMPATIBLE_PERIPHERAL = 16465,

  /**
   * @generated from enum value: VID_DEVICE_ERROR_INTERNAL_FAILURE = 16501;
   */
  VID_DEVICE_ERROR_INTERNAL_FAILURE = 16501,

  /**
   * @generated from enum value: VID_DEVICE_ERROR_UNDERVOLTAGE_LOCKOUT = 16426;
   */
  VID_DEVICE_ERROR_UNDERVOLTAGE_LOCKOUT = 16426,

  /**
   * @generated from enum value: VID_DEVICE_EXTERNAL_ANTENA = 32770;
   */
  VID_DEVICE_EXTERNAL_ANTENA = 32770,

  /**
   * @generated from enum value: VID_DEVICE_INTERNAL_OVERHEAT_TIME = 274;
   */
  VID_DEVICE_INTERNAL_OVERHEAT_TIME = 274,

  /**
   * @generated from enum value: VID_DEVICE_INTERNAL_TEMPERATURE = 267;
   */
  VID_DEVICE_INTERNAL_TEMPERATURE = 267,

  /**
   * @generated from enum value: VID_DEVICE_INTERNAL_TEMPERATURE_HISTOGRAM = 273;
   */
  VID_DEVICE_INTERNAL_TEMPERATURE_HISTOGRAM = 273,

  /**
   * @generated from enum value: VID_DEVICE_MODBUS_ADDRESS = 32769;
   */
  VID_DEVICE_MODBUS_ADDRESS = 32769,

  /**
   * @generated from enum value: VID_DEVICE_OWNER_ID = 32990;
   */
  VID_DEVICE_OWNER_ID = 32990,

  /**
   * @generated from enum value: VID_DEVICE_PC_TOOL_LIST = 34073;
   */
  VID_DEVICE_PC_TOOL_LIST = 34073,

  /**
   * @generated from enum value: VID_DEVICE_PERSISTENT_PARAMETERS_COMMAND = 300;
   */
  VID_DEVICE_PERSISTENT_PARAMETERS_COMMAND = 300,

  /**
   * @generated from enum value: VID_DEVICE_SIGNAL_STRENGTH_DEPRECATED = 115;
   */
  VID_DEVICE_SIGNAL_STRENGTH_DEPRECATED = 115,

  /**
   * @generated from enum value: VID_DEVICE_SIGNAL_STRENGTH_RX_OBSERVED_BY_PERIPHERAL = 117;
   */
  VID_DEVICE_SIGNAL_STRENGTH_RX_OBSERVED_BY_PERIPHERAL = 117,

  /**
   * @generated from enum value: VID_DEVICE_SIGNAL_STRENGTH_TX_OBSERVED_BY_CCU = 116;
   */
  VID_DEVICE_SIGNAL_STRENGTH_TX_OBSERVED_BY_CCU = 116,

  /**
   * @generated from enum value: VID_DEVICE_START_TIME = 236;
   */
  VID_DEVICE_START_TIME = 236,

  /**
   * @generated from enum value: VID_DEVICE_STATUS_FILTER = 186;
   */
  VID_DEVICE_STATUS_FILTER = 186,

  /**
   * @generated from enum value: VID_DEVICE_TRANSFER_REQUEST_LIST = 34071;
   */
  VID_DEVICE_TRANSFER_REQUEST_LIST = 34071,

  /**
   * @generated from enum value: VID_DEVICE_TRANSFER_STATUS_LIST = 34072;
   */
  VID_DEVICE_TRANSFER_STATUS_LIST = 34072,

  /**
   * @generated from enum value: VID_DEVICE_WARNING_LONG_POWER_FAIL = 16385;
   */
  VID_DEVICE_WARNING_LONG_POWER_FAIL = 16385,

  /**
   * @generated from enum value: VID_DEVICE_WARNING_LOST_COMMUNICATION_WITH_PERIPHERY = 16388;
   */
  VID_DEVICE_WARNING_LOST_COMMUNICATION_WITH_PERIPHERY = 16388,

  /**
   * @generated from enum value: VID_DEVICE_WARNING_POWER_FAIL = 16384;
   */
  VID_DEVICE_WARNING_POWER_FAIL = 16384,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_AIR_TEMP_SAMPLING_RATE_OVERRIDE = 312;
   */
  VID_DEVICE_RT_RS_2XX_AIR_TEMP_SAMPLING_RATE_OVERRIDE = 312,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_BRIGHTNESS_HIGH_LIMIT = 33059;
   */
  VID_DEVICE_RT_RS_2XX_BRIGHTNESS_HIGH_LIMIT = 33059,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_BRIGHTNESS_LOW_LIMIT = 33058;
   */
  VID_DEVICE_RT_RS_2XX_BRIGHTNESS_LOW_LIMIT = 33058,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CO2_ASC_SETTINGS = 34096;
   */
  VID_DEVICE_RT_RS_2XX_CO2_ASC_SETTINGS = 34096,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CO2_LAST_CORRECTION_PPM = 327;
   */
  VID_DEVICE_RT_RS_2XX_CO2_LAST_CORRECTION_PPM = 327,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CO2_LED_INDICATION_SETUP = 34078;
   */
  VID_DEVICE_RT_RS_2XX_CO2_LED_INDICATION_SETUP = 34078,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CO2_MANUAL_TARGET_CONCENTRATION_PPM = 326;
   */
  VID_DEVICE_RT_RS_2XX_CO2_MANUAL_TARGET_CONCENTRATION_PPM = 326,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CORRECTION_AIR_TEMP = 33055;
   */
  VID_DEVICE_RT_RS_2XX_CORRECTION_AIR_TEMP = 33055,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CORRECTION_FLOOR_TEMP = 33056;
   */
  VID_DEVICE_RT_RS_2XX_CORRECTION_FLOOR_TEMP = 33056,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_CORRECTION_HUMIDITY = 33057;
   */
  VID_DEVICE_RT_RS_2XX_CORRECTION_HUMIDITY = 33057,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HEATER_HOLD_TIME = 309;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HEATER_HOLD_TIME = 309,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HEATER_SETPOINT = 310;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HEATER_SETPOINT = 310,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HEATING_HISTOGRAM = 313;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HEATING_HISTOGRAM = 313,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HEATING_RESULT = 311;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HEATING_RESULT = 311,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HUMIDITY_OFFSET_CORRECTION_LOG = 34094;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HUMIDITY_OFFSET_CORRECTION_LOG = 34094,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_HDC2080_HUMIDITY_OFFSET_CORRECTION_SETTINGS = 315;
   */
  VID_DEVICE_RT_RS_2XX_HDC2080_HUMIDITY_OFFSET_CORRECTION_SETTINGS = 315,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_THERMOSTAT_LOCAL_LOCK = 32910;
   */
  VID_DEVICE_RT_RS_2XX_THERMOSTAT_LOCAL_LOCK = 32910,

  /**
   * @generated from enum value: VID_DEVICE_RT_RS_2XX_TOUCH_SENSITIVITY = 33060;
   */
  VID_DEVICE_RT_RS_2XX_TOUCH_SENSITIVITY = 33060,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_ACKNOWLEDGE_DEVICE_SPECIFIC_ERROR = 51249;
   */
  VID_DEVICE_VENTILATION_ACKNOWLEDGE_DEVICE_SPECIFIC_ERROR = 51249,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_ACKNOWLEDGE_DEVICE_SPECIFIC_WARNING = 51250;
   */
  VID_DEVICE_VENTILATION_ACKNOWLEDGE_DEVICE_SPECIFIC_WARNING = 51250,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_AIR_FILTER_LAST_CHANGE = 49196;
   */
  VID_DEVICE_VENTILATION_AIR_FILTER_LAST_CHANGE = 49196,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_AIR_FILTER_LIFETIME_HOURS = 49187;
   */
  VID_DEVICE_VENTILATION_AIR_FILTER_LIFETIME_HOURS = 49187,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_DEVICE_STATE = 49184;
   */
  VID_DEVICE_VENTILATION_DEVICE_STATE = 49184,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_ERROR_DEVICE_LOST = 50194;
   */
  VID_DEVICE_VENTILATION_ERROR_DEVICE_LOST = 50194,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_ERROR_DEVICE_SPECIFIC = 50197;
   */
  VID_DEVICE_VENTILATION_ERROR_DEVICE_SPECIFIC = 50197,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_FEATURES = 49181;
   */
  VID_DEVICE_VENTILATION_FEATURES = 49181,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_HEAT_RECOVERY_BYPASS_MODE = 51248;
   */
  VID_DEVICE_VENTILATION_HEAT_RECOVERY_BYPASS_MODE = 51248,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_HEAT_RECOVERY_BYPASS_STATE = 49185;
   */
  VID_DEVICE_VENTILATION_HEAT_RECOVERY_BYPASS_STATE = 49185,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_ID = 49180;
   */
  VID_DEVICE_VENTILATION_ID = 49180,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_MAINTENANCE_REQUEST = 49197;
   */
  VID_DEVICE_VENTILATION_MAINTENANCE_REQUEST = 49197,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_MAINTENANCE_STATE = 49192;
   */
  VID_DEVICE_VENTILATION_MAINTENANCE_STATE = 49192,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_MAINTENANCE_STATE_TRANSITION_TIME = 49194;
   */
  VID_DEVICE_VENTILATION_MAINTENANCE_STATE_TRANSITION_TIME = 49194,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_NAME = 51242;
   */
  VID_DEVICE_VENTILATION_NAME = 51242,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_QUIET_HOURS_ACTIVE = 49203;
   */
  VID_DEVICE_VENTILATION_QUIET_HOURS_ACTIVE = 49203,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_QUIET_HOURS_ENABLE = 51259;
   */
  VID_DEVICE_VENTILATION_QUIET_HOURS_ENABLE = 51259,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_QUIET_HOURS_INTERVAL = 51260;
   */
  VID_DEVICE_VENTILATION_QUIET_HOURS_INTERVAL = 51260,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_QUIET_HOURS_LOWERED_LEVEL = 49204;
   */
  VID_DEVICE_VENTILATION_QUIET_HOURS_LOWERED_LEVEL = 49204,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_STATE_NAME_BOOST = 51256;
   */
  VID_DEVICE_VENTILATION_STATE_NAME_BOOST = 51256,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_STATE_NAME_COMFORT = 51255;
   */
  VID_DEVICE_VENTILATION_STATE_NAME_COMFORT = 51255,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_STATE_NAME_ECO = 51254;
   */
  VID_DEVICE_VENTILATION_STATE_NAME_ECO = 51254,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_STATE_NAME_STOPPED = 51252;
   */
  VID_DEVICE_VENTILATION_STATE_NAME_STOPPED = 51252,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_STATE_NAME_UNOCCUPIED = 51253;
   */
  VID_DEVICE_VENTILATION_STATE_NAME_UNOCCUPIED = 51253,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VACATION_IS_ALLOWED = 49186;
   */
  VID_DEVICE_VENTILATION_VACATION_IS_ALLOWED = 49186,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_BLOCKING = 49182;
   */
  VID_DEVICE_VENTILATION_VENTILATION_BLOCKING = 49182,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_LEVEL = 51245;
   */
  VID_DEVICE_VENTILATION_VENTILATION_LEVEL = 51245,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE = 51246;
   */
  VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE = 51246,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE_SOURCE = 49188;
   */
  VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE_SOURCE = 49188,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE_UNTIL = 51247;
   */
  VID_DEVICE_VENTILATION_VENTILATION_MODE_OVERRIDE_UNTIL = 51247,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_OVERRIDE = 51257;
   */
  VID_DEVICE_VENTILATION_VENTILATION_OVERRIDE = 51257,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_SCHEDULER = 51244;
   */
  VID_DEVICE_VENTILATION_VENTILATION_SCHEDULER = 51244,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_SCHEDULER_ENABLED = 51243;
   */
  VID_DEVICE_VENTILATION_VENTILATION_SCHEDULER_ENABLED = 51243,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_VENTILATION_STATE = 49183;
   */
  VID_DEVICE_VENTILATION_VENTILATION_STATE = 49183,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_WARNING_DEVICE_SPECIFIC = 50198;
   */
  VID_DEVICE_VENTILATION_WARNING_DEVICE_SPECIFIC = 50198,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_WARNING_FILTER_MAINTENANCE = 50195;
   */
  VID_DEVICE_VENTILATION_WARNING_FILTER_MAINTENANCE = 50195,

  /**
   * @generated from enum value: VID_DEVICE_VENTILATION_WARNING_VENTILATION_RESTART = 50196;
   */
  VID_DEVICE_VENTILATION_WARNING_VENTILATION_RESTART = 50196,

  /**
   * @generated from enum value: VID_DEVICE_VH_250_ERROR_BADLY_INSTALLED = 16424;
   */
  VID_DEVICE_VH_250_ERROR_BADLY_INSTALLED = 16424,

  /**
   * @generated from enum value: VID_DEVICE_VH_250_ERROR_BATTERY_OPEN = 16423;
   */
  VID_DEVICE_VH_250_ERROR_BATTERY_OPEN = 16423,

  /**
   * @generated from enum value: VID_DEVICE_VH_250_ERROR_VALVE_STICKED = 16459;
   */
  VID_DEVICE_VH_250_ERROR_VALVE_STICKED = 16459,

  /**
   * @generated from enum value: VID_DHW_NO_SECONDARY_SIDE_PRESSURE_HYSTERESIS = 33103;
   */
  VID_DHW_NO_SECONDARY_SIDE_PRESSURE_HYSTERESIS = 33103,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BACKUP_CHARGE_TIME = 277;
   */
  VID_DHW_201_CONTROLLER_BACKUP_CHARGE_TIME = 277,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BOOST_SOURCE_PUMP_MODE = 32841;
   */
  VID_DHW_201_CONTROLLER_BOOST_SOURCE_PUMP_MODE = 32841,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BOOST_SOURCE_PUMP_STATE = 52;
   */
  VID_DHW_201_CONTROLLER_BOOST_SOURCE_PUMP_STATE = 52,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_DEFROST_MODE = 32849;
   */
  VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_DEFROST_MODE = 32849,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_DEFROST_TEMP_ECO = 32850;
   */
  VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_DEFROST_TEMP_ECO = 32850,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SET_COMFORT = 32921;
   */
  VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SET_COMFORT = 32921,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SPAN_MAX = 32920;
   */
  VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SPAN_MAX = 32920,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SPAN_MIN = 32919;
   */
  VID_DHW_201_CONTROLLER_BYPASS_SOURCE_INLET_TEMP_SPAN_MIN = 32919,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_DYNAMIC_MODE = 34037;
   */
  VID_DHW_201_CONTROLLER_DYNAMIC_MODE = 34037,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_DYNAMIC_SETPOINT = 34039;
   */
  VID_DHW_201_CONTROLLER_DYNAMIC_SETPOINT = 34039,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_DYNAMIC_WAIT_TIME = 34038;
   */
  VID_DHW_201_CONTROLLER_DYNAMIC_WAIT_TIME = 34038,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_ENERGY_PRIORITY_MODE = 32865;
   */
  VID_DHW_201_CONTROLLER_ENERGY_PRIORITY_MODE = 32865,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_ENERGY_PRIORITY_STATE = 42;
   */
  VID_DHW_201_CONTROLLER_ENERGY_PRIORITY_STATE = 42,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_FLOW_SENSOR_TYPE = 33933;
   */
  VID_DHW_201_CONTROLLER_FLOW_SENSOR_TYPE = 33933,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_HEX_FACTOR = 34040;
   */
  VID_DHW_201_CONTROLLER_HEX_FACTOR = 34040,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_MOTOR_TEST_VALUE = 276;
   */
  VID_DHW_201_CONTROLLER_MOTOR_TEST_VALUE = 276,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_POWER_CONSUMPTION_LIMIT = 32924;
   */
  VID_DHW_201_CONTROLLER_POWER_CONSUMPTION_LIMIT = 32924,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_REGULATOR_MODE = 265;
   */
  VID_DHW_201_CONTROLLER_REGULATOR_MODE = 265,

  /**
   * @generated from enum value: VID_DHW_201_CONTROLLER_SOURCE_VALVE_LEVEL = 43;
   */
  VID_DHW_201_CONTROLLER_SOURCE_VALVE_LEVEL = 43,

  /**
   * @generated from enum value: VID_DHW_21X_CONTROLLER_ALLOW_HEATING_DURING_DHW_DEMAND = 34066;
   */
  VID_DHW_21X_CONTROLLER_ALLOW_HEATING_DURING_DHW_DEMAND = 34066,

  /**
   * @generated from enum value: VID_DHW_21X_CONTROLLER_ERROR_FROST_PROTECTION_ACTIVE = 16506;
   */
  VID_DHW_21X_CONTROLLER_ERROR_FROST_PROTECTION_ACTIVE = 16506,

  /**
   * @generated from enum value: VID_DHW_21X_CONTROLLER_ERROR_MOTOR_STUCK = 16511;
   */
  VID_DHW_21X_CONTROLLER_ERROR_MOTOR_STUCK = 16511,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_COOLDOWN_TIME = 33097;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_COOLDOWN_TIME = 33097,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_PUMP_PRESENT = 32846;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_PUMP_PRESENT = 32846,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_RETURN_TEMP = 48;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_RETURN_TEMP = 48,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_STATE = 53;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_STATE = 53,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_DIFFERENCE = 33096;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_DIFFERENCE = 33096,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_HYSTERESIS = 32848;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_HYSTERESIS = 32848,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SET = 32847;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SET = 32847,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SPAN_MAX = 32923;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SPAN_MAX = 32923,

  /**
   * @generated from enum value: VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SPAN_MIN = 32922;
   */
  VID_DHW_CIRCULATION_CONTROLLER_CIRCULATION_TEMP_SPAN_MIN = 32922,

  /**
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_HEAT_VALVE_LEVEL = 268;
   */
  VID_DHW_HEATING_CONTROLLER_HEAT_VALVE_LEVEL = 268,

  /**
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_MOTOR_TEST_VALUE = 278;
   */
  VID_DHW_HEATING_CONTROLLER_MOTOR_TEST_VALUE = 278,

  /**
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_REGULATOR_MODE = 269;
   */
  VID_DHW_HEATING_CONTROLLER_REGULATOR_MODE = 269,

  /**
   * @generated from enum value: VID_DHW_HEATING_CONTROLLER_STATE = 279;
   */
  VID_DHW_HEATING_CONTROLLER_STATE = 279,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_CONTROL = 33098;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_CONTROL = 33098,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_CONTROL_WRONG_TYPE = 32877;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_CONTROL_WRONG_TYPE = 32877,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_ERROR_SOURCE_RETURN_TEMP_SENSOR_FAIL = 16443;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_ERROR_SOURCE_RETURN_TEMP_SENSOR_FAIL = 16443,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_ERROR_SOURCE_RETURN_TEMP_SENSOR_FAIL_WRONG_TYPE = 16425;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_ERROR_SOURCE_RETURN_TEMP_SENSOR_FAIL_WRONG_TYPE = 16425,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_SERVO_REQUEST = 120;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_SERVO_REQUEST = 120,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_SOURCE_RETURN_TEMP_LIMIT = 32878;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_SOURCE_RETURN_TEMP_LIMIT = 32878,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_WARNING_LOW_ENERGY = 16440;
   */
  VID_DHW_TANK_CONTROLLER_ADVANCED_TANK_WARNING_LOW_ENERGY = 16440,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_ENABLED = 33081;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_ENABLED = 33081,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_HOLD_TIME = 33051;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_HOLD_TIME = 33051,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_INTERVAL = 33050;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_INTERVAL = 33050,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_LAST = 33089;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_LAST = 33089,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_TIME_BEFORE_FAIL = 33052;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_TIME_BEFORE_FAIL = 33052,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_CLEANING_WARNING_FAIL = 16417;
   */
  VID_DHW_TANK_CONTROLLER_CLEANING_WARNING_FAIL = 16417,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ERROR_PERIPHERAL_UNREACHABLE = 16439;
   */
  VID_DHW_TANK_CONTROLLER_ERROR_PERIPHERAL_UNREACHABLE = 16439,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ERROR_SOURCE_INLET_SENSOR_FAIL = 16441;
   */
  VID_DHW_TANK_CONTROLLER_ERROR_SOURCE_INLET_SENSOR_FAIL = 16441,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_ERROR_TANK_SENSOR_FAIL = 16416;
   */
  VID_DHW_TANK_CONTROLLER_ERROR_TANK_SENSOR_FAIL = 16416,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_SOURCE_VALVE_LEVEL = 122;
   */
  VID_DHW_TANK_CONTROLLER_SOURCE_VALVE_LEVEL = 122,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP = 97;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP = 97,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_DESIRED = 98;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_DESIRED = 98,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_HYSTERESIS = 33049;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_HYSTERESIS = 33049,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET = 33093;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET = 33093,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_CLEANING = 33048;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_CLEANING = 33048,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_COMFORT = 33045;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_COMFORT = 33045,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_ECO = 33044;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_ECO = 33044,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_STANDBY = 33046;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_STANDBY = 33046,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_VACATION = 33047;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SET_VACATION = 33047,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SPAN_MAX = 33054;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SPAN_MAX = 33054,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_TANK_TEMP_SPAN_MIN = 33053;
   */
  VID_DHW_TANK_CONTROLLER_TANK_TEMP_SPAN_MIN = 33053,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_WARNING_LOW_SOURCE_TEMP = 16442;
   */
  VID_DHW_TANK_CONTROLLER_WARNING_LOW_SOURCE_TEMP = 16442,

  /**
   * @generated from enum value: VID_DHW_TANK_CONTROLLER_WARNING_PERIPHERAL_LOW_BATTERY = 16438;
   */
  VID_DHW_TANK_CONTROLLER_WARNING_PERIPHERAL_LOW_BATTERY = 16438,

  /**
   * @generated from enum value: VID_DIAGNOSTICS_SYSLOG_CHANGE_DESTINATION_IP = 33889;
   */
  VID_DIAGNOSTICS_SYSLOG_CHANGE_DESTINATION_IP = 33889,

  /**
   * @generated from enum value: VID_DIAGNOSTICS_SYSLOG_CHANGE_DESTINATION_PORT = 33914;
   */
  VID_DIAGNOSTICS_SYSLOG_CHANGE_DESTINATION_PORT = 33914,

  /**
   * @generated from enum value: VID_DIAGNOSTICS_TELEMETRY_REPORTING_DESTINATION_IP = 34097;
   */
  VID_DIAGNOSTICS_TELEMETRY_REPORTING_DESTINATION_IP = 34097,

  /**
   * @generated from enum value: VID_DIAGNOSTICS_TELEMETRY_REPORTING_DESTINATION_PORT = 34098;
   */
  VID_DIAGNOSTICS_TELEMETRY_REPORTING_DESTINATION_PORT = 34098,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_ALLOW_STANDBY = 33043;
   */
  VID_DOMESTIC_HOT_WATER_ALLOW_STANDBY = 33043,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_ALLOW_VACATION_AWAY = 32909;
   */
  VID_DOMESTIC_HOT_WATER_ALLOW_VACATION_AWAY = 32909,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_BLOCKING_SOURCE = 37;
   */
  VID_DOMESTIC_HOT_WATER_BLOCKING_SOURCE = 37,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_BLOCK_REQUEST_FROM_BMS = 33063;
   */
  VID_DOMESTIC_HOT_WATER_BLOCK_REQUEST_FROM_BMS = 33063,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_DEVICE_UI_ACCESS_LEVEL = 32908;
   */
  VID_DOMESTIC_HOT_WATER_DEVICE_UI_ACCESS_LEVEL = 32908,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_MODE = 32905;
   */
  VID_DOMESTIC_HOT_WATER_MODE = 32905,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_SCHEDULE_ECO_COMFORT = 32907;
   */
  VID_DOMESTIC_HOT_WATER_SCHEDULE_ECO_COMFORT = 32907,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_STATE = 36;
   */
  VID_DOMESTIC_HOT_WATER_STATE = 36,

  /**
   * @generated from enum value: VID_DOMESTIC_HOT_WATER_WARNING_GENERAL_PROBLEM = 16406;
   */
  VID_DOMESTIC_HOT_WATER_WARNING_GENERAL_PROBLEM = 16406,

  /**
   * @generated from enum value: VID_DRYING_BLOCKING = 148;
   */
  VID_DRYING_BLOCKING = 148,

  /**
   * @generated from enum value: VID_DRYING_CONSUMER_LIST = 33833;
   */
  VID_DRYING_CONSUMER_LIST = 33833,

  /**
   * Common ventilation
   *
   * @generated from enum value: VID_DRYING_CONTROLLER_ALLOW_MODE = 33835;
   */
  VID_DRYING_CONTROLLER_ALLOW_MODE = 33835,

  /**
   * @generated from enum value: VID_DRYING_CONTROLLER_MAINTENANCE_ENDS_SOON_WARNING = 16498;
   */
  VID_DRYING_CONTROLLER_MAINTENANCE_ENDS_SOON_WARNING = 16498,

  /**
   * @generated from enum value: VID_DRYING_CONTROLLER_REQUIRED_DRYING_COOLING_WATER_TEMP = 33852;
   */
  VID_DRYING_CONTROLLER_REQUIRED_DRYING_COOLING_WATER_TEMP = 33852,

  /**
   * @generated from enum value: VID_DRYING_SOURCE_DEMAND = 152;
   */
  VID_DRYING_SOURCE_DEMAND = 152,

  /**
   * @generated from enum value: VID_DRYING_SOURCE_STATUS = 147;
   */
  VID_DRYING_SOURCE_STATUS = 147,

  /**
   * @generated from enum value: VID_DRYING_SOURCE_SUPPLIER_OID = 33834;
   */
  VID_DRYING_SOURCE_SUPPLIER_OID = 33834,

  /**
   * @generated from enum value: VID_ETHERNET_DEFAULT_GATEWAY = 184;
   */
  VID_ETHERNET_DEFAULT_GATEWAY = 184,

  /**
   * @generated from enum value: VID_ETHERNET_DHCP_LEASE_TIME = 174;
   */
  VID_ETHERNET_DHCP_LEASE_TIME = 174,

  /**
   * @generated from enum value: VID_ETHERNET_IP_ADDRESS = 182;
   */
  VID_ETHERNET_IP_ADDRESS = 182,

  /**
   * @generated from enum value: VID_ETHERNET_IP_CONFIGURATION = 33907;
   */
  VID_ETHERNET_IP_CONFIGURATION = 33907,

  /**
   * @generated from enum value: VID_ETHERNET_MAC_ADDRESS = 33906;
   */
  VID_ETHERNET_MAC_ADDRESS = 33906,

  /**
   * @generated from enum value: VID_ETHERNET_SERVICE_MASK = 34009;
   */
  VID_ETHERNET_SERVICE_MASK = 34009,

  /**
   * @generated from enum value: VID_ETHERNET_STATIC_DEFAULT_GATEWAY = 33910;
   */
  VID_ETHERNET_STATIC_DEFAULT_GATEWAY = 33910,

  /**
   * @generated from enum value: VID_ETHERNET_STATIC_IP_ADDRESS = 33908;
   */
  VID_ETHERNET_STATIC_IP_ADDRESS = 33908,

  /**
   * @generated from enum value: VID_ETHERNET_STATIC_SUBNET_MASK = 33909;
   */
  VID_ETHERNET_STATIC_SUBNET_MASK = 33909,

  /**
   * @generated from enum value: VID_ETHERNET_SUBNET_MASK = 183;
   */
  VID_ETHERNET_SUBNET_MASK = 183,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_DEVICE_SPECIFIC_ERROR_ACKNOWLEDGE = 229;
   */
  VID_EXTERNAL_DEVICE_DEVICE_SPECIFIC_ERROR_ACKNOWLEDGE = 229,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_DEVICE_SPECIFIC_WARNING_ACKNOWLEDGE = 230;
   */
  VID_EXTERNAL_DEVICE_DEVICE_SPECIFIC_WARNING_ACKNOWLEDGE = 230,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_ERROR_HCW_SUPPLIER_NOT_SET = 16448;
   */
  VID_EXTERNAL_DEVICE_ERROR_HCW_SUPPLIER_NOT_SET = 16448,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_INTERFACE_MODBUS_SLAVE_ID = 33974;
   */
  VID_EXTERNAL_DEVICE_INTERFACE_MODBUS_SLAVE_ID = 33974,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALLOW_STOPPED_LEVEL = 33971;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALLOW_STOPPED_LEVEL = 33971,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALLOW_UNOCCUPIED_LEVEL = 34041;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_ALLOW_UNOCCUPIED_LEVEL = 34041,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_COOLING_INTAKE_AIR_TEMPERATURE_LIMIT = 34010;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_COOLING_INTAKE_AIR_TEMPERATURE_LIMIT = 34010,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_IDENTIFICATION_STRATEGY = 34011;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_IDENTIFICATION_STRATEGY = 34011,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_MANUFACTURER = 251;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_MANUFACTURER = 251,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_MODEL = 252;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_MODEL = 252,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_STATE = 248;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DEVICE_STATE = 248,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DISTRIBUTION_STATUS = 234;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_DISTRIBUTION_STATUS = 234,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_AIR_TEMPERATURE = 228;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_AIR_TEMPERATURE = 228,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_BOOST_PERCENT = 33962;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_BOOST_PERCENT = 33962,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_BOOST_M3 = 33995;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_BOOST_M3 = 33995,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_COMFORT_PERCENT = 33961;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_COMFORT_PERCENT = 33961,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_COMFORT_M3 = 33994;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_COMFORT_M3 = 33994,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_ECO_PERCENT = 33960;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_ECO_PERCENT = 33960,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_ECO_M3 = 33993;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_ECO_M3 = 33993,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_UNOCCUPIED_PERCENT = 33959;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_UNOCCUPIED_PERCENT = 33959,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_UNOCCUPIED_M3 = 33992;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_LEVEL_UNOCCUPIED_M3 = 33992,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MAXIMUM_SPEED_PERCENT = 34043;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MAXIMUM_SPEED_PERCENT = 34043,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MAXIMUM_VOLUME_FLOW = 34000;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MAXIMUM_VOLUME_FLOW = 34000,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MINIMUM_SPEED_PERCENT = 34042;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MINIMUM_SPEED_PERCENT = 34042,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MINIMUM_VOLUME_FLOW = 34002;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_MINIMUM_VOLUME_FLOW = 34002,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_SPEED_PERCENT = 232;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_SPEED_PERCENT = 232,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_SPEED_RPM = 286;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_FAN_SPEED_RPM = 286,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_VOLUME_FLOW_M3 = 244;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXHAUST_VOLUME_FLOW_M3 = 244,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXTRACT_AIR_TEMPERATURE = 227;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_EXTRACT_AIR_TEMPERATURE = 227,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_FREE_COOLING_ENABLED = 249;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_FREE_COOLING_ENABLED = 249,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_HEAT_RECOVERY_BYPASS_DAMPER_POSITION_PERCENT = 235;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_HEAT_RECOVERY_BYPASS_DAMPER_POSITION_PERCENT = 235,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_HEAT_RECOVERY_BYPASS_MODE = 33970;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_HEAT_RECOVERY_BYPASS_MODE = 33970,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_INTAKE_AIR_TEMPERATURE = 225;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_INTAKE_AIR_TEMPERATURE = 225,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_ACTIVE = 304;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_ACTIVE = 304,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_ENABLE = 34069;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_ENABLE = 34069,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_INTERVAL = 34070;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_QUIET_HOURS_INTERVAL = 34070,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_BOOST = 34008;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_BOOST = 34008,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_COMFORT = 34007;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_COMFORT = 34007,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_ECO = 34006;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_ECO = 34006,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_STOPPED = 34004;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_STOPPED = 34004,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_UNOCCUPIED = 34005;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_STATE_NAME_UNOCCUPIED = 34005,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_AIR_TEMPERATURE = 226;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_AIR_TEMPERATURE = 226,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_BOOST_PERCENT = 33982;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_BOOST_PERCENT = 33982,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_BOOST_M3 = 33999;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_BOOST_M3 = 33999,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_COMFORT_PERCENT = 33981;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_COMFORT_PERCENT = 33981,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_COMFORT_M3 = 33998;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_COMFORT_M3 = 33998,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_ECO_PERCENT = 33980;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_ECO_PERCENT = 33980,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_ECO_M3 = 33997;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_ECO_M3 = 33997,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_UNOCCUPIED_PERCENT = 33979;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_UNOCCUPIED_PERCENT = 33979,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_UNOCCUPIED_M3 = 33996;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_LEVEL_UNOCCUPIED_M3 = 33996,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MAXIMUM_SPEED_PERCENT = 34045;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MAXIMUM_SPEED_PERCENT = 34045,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MAXIMUM_VOLUME_FLOW = 34001;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MAXIMUM_VOLUME_FLOW = 34001,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MINIMUM_SPEED_PERCENT = 34044;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MINIMUM_SPEED_PERCENT = 34044,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MINIMUM_VOLUME_FLOW = 34003;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_MINIMUM_VOLUME_FLOW = 34003,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_SPEED_PERCENT = 231;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_SPEED_PERCENT = 231,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_SPEED_RPM = 285;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_FAN_SPEED_RPM = 285,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_VOLUME_FLOW_M3 = 243;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_SUPPLY_VOLUME_FLOW_M3 = 243,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_OVERRIDE = 33966;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_OVERRIDE = 33966,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_STANDBY = 33973;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_STANDBY = 33973,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_VACATION = 33972;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_LEVEL_VACATION = 33972,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE = 33967;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE = 33967,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE_SOURCE = 33968;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE_SOURCE = 33968,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE_UNTIL = 33969;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_MODE_OVERRIDE_UNTIL = 33969,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_SCHEDULER = 33964;
   */
  VID_EXTERNAL_DEVICE_MECHANICAL_VENTILATION_VENTILATION_SCHEDULER = 33964,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_DRYING_DEMAND = 144;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_DRYING_DEMAND = 144,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_EXTA_DEMAND = 143;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_EXTA_DEMAND = 143,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_BOOST_DEMAND = 284;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_BOOST_DEMAND = 284,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_COMFORT_DEMAND = 283;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_COMFORT_DEMAND = 283,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_ECO_DEMAND = 282;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_ECO_DEMAND = 282,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_UNOCCUPIED_DEMAND = 281;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_FAN_UNOCCUPIED_DEMAND = 281,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_HEAT_RECOVERY_BYPASS_DAMPER_DEMAND = 233;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_HEAT_RECOVERY_BYPASS_DAMPER_DEMAND = 233,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_INTEGRATION_DEMAND = 145;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_INTEGRATION_DEMAND = 145,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_PUMP_DEMAND = 142;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_PUMP_DEMAND = 142,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_VENTILATION_DEMAND = 146;
   */
  VID_EXTERNAL_DEVICE_OUTPUT_SIGNALS_VENTILATION_DEMAND = 146,

  /**
   * @generated from enum value: VID_EXTERNAL_DEVICE_TYPE_SEE_OBJECT_INFO_SUBTYPE = 33832;
   */
  VID_EXTERNAL_DEVICE_TYPE_SEE_OBJECT_INFO_SUBTYPE = 33832,

  /**
   * @generated from enum value: VID_GRAPHIC_INTERFACE_BACKLIGHT_BRIGHTNESS = 34030;
   */
  VID_GRAPHIC_INTERFACE_BACKLIGHT_BRIGHTNESS = 34030,

  /**
   * @generated from enum value: VID_GRAPHIC_INTERFACE_BUTTON_PRESSED_IN_TEST_MODE = 298;
   */
  VID_GRAPHIC_INTERFACE_BUTTON_PRESSED_IN_TEST_MODE = 298,

  /**
   * @generated from enum value: VID_GRAPHIC_INTERFACE_TEST_MODE_SCREEN = 297;
   */
  VID_GRAPHIC_INTERFACE_TEST_MODE_SCREEN = 297,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_HTCO_ALARM = 16415;
   */
  VID_HCC_HEATING_CONTROLLER_HTCO_ALARM = 16415,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_HTCO_INTEGRATION_THRESHOLD = 33911;
   */
  VID_HCC_HEATING_CONTROLLER_HTCO_INTEGRATION_THRESHOLD = 33911,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_HTCO_MODE = 33017;
   */
  VID_HCC_HEATING_CONTROLLER_HTCO_MODE = 33017,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_HTCO_TEMPERATURE = 33014;
   */
  VID_HCC_HEATING_CONTROLLER_HTCO_TEMPERATURE = 33014,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_HTCO_TEMPERATURE_RELATIVE = 33025;
   */
  VID_HCC_HEATING_CONTROLLER_HTCO_TEMPERATURE_RELATIVE = 33025,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_OUTDOOR_TEMPERATURE_CUT_OFF = 33035;
   */
  VID_HCC_HEATING_CONTROLLER_OUTDOOR_TEMPERATURE_CUT_OFF = 33035,

  /**
   * @generated from enum value: VID_HCC_HEATING_CONTROLLER_SOURCE_DEMAND = 83;
   */
  VID_HCC_HEATING_CONTROLLER_SOURCE_DEMAND = 83,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_ASSOCIATED_PUMP = 33890;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_ASSOCIATED_PUMP = 33890,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_CONFIGURATION = 34083;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_CONFIGURATION = 34083,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_DESIRED_INLET_TEMP = 191;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_DESIRED_INLET_TEMP = 191,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_DESIRED_ROOM_TEMP_BY_CONSUMERS = 84;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_DESIRED_ROOM_TEMP_BY_CONSUMERS = 84,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_ERROR_INLET_SENSOR_FAILURE = 16414;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_ERROR_INLET_SENSOR_FAILURE = 16414,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_MODE = 33018;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_MODE = 33018,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_PUMP_DEMAND = 123;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_PUMP_DEMAND = 123,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_PUMP_STATUS = 85;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_PUMP_STATUS = 85,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_SERVO_REQUEST = 270;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_SERVO_REQUEST = 270,

  /**
   * @generated from enum value: VID_HCC_OBJECT_HEATING_COOLING_CONTROL_STATE = 101;
   */
  VID_HCC_OBJECT_HEATING_COOLING_CONTROL_STATE = 101,

  /**
   * @generated from enum value: VID_HEATING_COOLING_AUTO_SWITCHING_SAMPLES = 34020;
   */
  VID_HEATING_COOLING_AUTO_SWITCHING_SAMPLES = 34020,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_CONSECUTIVE_DAYS = 34025;
   */
  VID_HEATING_COOLING_COOLING_CONSECUTIVE_DAYS = 34025,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_INTERMITTENT_DAYS = 34026;
   */
  VID_HEATING_COOLING_COOLING_INTERMITTENT_DAYS = 34026,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_INTERMITTENT_DAYS_PERIOD = 34027;
   */
  VID_HEATING_COOLING_COOLING_INTERMITTENT_DAYS_PERIOD = 34027,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_MINIMUM_OUTDOOR_TEMPERATURE = 33023;
   */
  VID_HEATING_COOLING_COOLING_MINIMUM_OUTDOOR_TEMPERATURE = 33023,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_PERIOD_LENGTH_HOURS = 34028;
   */
  VID_HEATING_COOLING_COOLING_PERIOD_LENGTH_HOURS = 34028,

  /**
   * @generated from enum value: VID_HEATING_COOLING_COOLING_SINCE = 32833;
   */
  VID_HEATING_COOLING_COOLING_SINCE = 32833,

  /**
   * @generated from enum value: VID_HEATING_COOLING_DEW_POINT_OFFSET = 33024;
   */
  VID_HEATING_COOLING_DEW_POINT_OFFSET = 33024,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_CONSECUTIVE_DAYS = 34021;
   */
  VID_HEATING_COOLING_HEATING_CONSECUTIVE_DAYS = 34021,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_COOLING_DEADBAND_TEMPERATURE = 33019;
   */
  VID_HEATING_COOLING_HEATING_COOLING_DEADBAND_TEMPERATURE = 33019,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_COOLING_MODE_HW_SOURCE = 34019;
   */
  VID_HEATING_COOLING_HEATING_COOLING_MODE_HW_SOURCE = 34019,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_COOLING_MODE_LAST_TRANSITION = 33013;
   */
  VID_HEATING_COOLING_HEATING_COOLING_MODE_LAST_TRANSITION = 33013,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_COOLING_MODE_SWITCH_COOLDOWN = 33020;
   */
  VID_HEATING_COOLING_HEATING_COOLING_MODE_SWITCH_COOLDOWN = 33020,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_INTERMITTENT_DAYS = 34022;
   */
  VID_HEATING_COOLING_HEATING_INTERMITTENT_DAYS = 34022,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_INTERMITTENT_DAYS_PERIOD = 34023;
   */
  VID_HEATING_COOLING_HEATING_INTERMITTENT_DAYS_PERIOD = 34023,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_MAXIMUM_OUTDOOR_TEMPERATURE = 33088;
   */
  VID_HEATING_COOLING_HEATING_MAXIMUM_OUTDOOR_TEMPERATURE = 33088,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_PERIOD_LENGTH_HOURS = 34024;
   */
  VID_HEATING_COOLING_HEATING_PERIOD_LENGTH_HOURS = 34024,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HEATING_SINCE = 32887;
   */
  VID_HEATING_COOLING_HEATING_SINCE = 32887,

  /**
   * @generated from enum value: VID_HEATING_COOLING_HOURS_WITHOUT_DEMAND_TO_CHANGE_OVER = 34085;
   */
  VID_HEATING_COOLING_HOURS_WITHOUT_DEMAND_TO_CHANGE_OVER = 34085,

  /**
   * @generated from enum value: VID_HEATING_COOLING_PERIOD_TIMER_START = 271;
   */
  VID_HEATING_COOLING_PERIOD_TIMER_START = 271,

  /**
   * @generated from enum value: VID_HEATING_COOLING_REFERENCE_ROOM_CHANGE_OVER_DEMAND = 314;
   */
  VID_HEATING_COOLING_REFERENCE_ROOM_CHANGE_OVER_DEMAND = 314,

  /**
   * @generated from enum value: VID_HEATING_COOLING_REFERENCE_ROOM_HISTOGRAM = 34084;
   */
  VID_HEATING_COOLING_REFERENCE_ROOM_HISTOGRAM = 34084,

  /**
   * @generated from enum value: VID_HEATING_COOLING_REFERENCE_ROOM_HISTOGRAM_COUNTER_PERIOD_SECONDS = 34086;
   */
  VID_HEATING_COOLING_REFERENCE_ROOM_HISTOGRAM_COUNTER_PERIOD_SECONDS = 34086,

  /**
   * @generated from enum value: VID_HEATING_COOLING_REFERENCE_ROOM_OID = 34082;
   */
  VID_HEATING_COOLING_REFERENCE_ROOM_OID = 34082,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_BLOCKING = 88;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_BLOCKING = 88,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_CONSUMER_LIST = 33092;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_CONSUMER_LIST = 33092,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_ERROR_SUPPLIER_UNAVAILABLE = 16507;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_ERROR_SUPPLIER_UNAVAILABLE = 16507,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_FLOW_RATE = 322;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_FLOW_RATE = 322,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_INLET_TEMP = 25;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_INLET_TEMP = 25,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_INLET_TEMP_REFERENCE = 33888;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_INLET_TEMP_REFERENCE = 33888,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_PRESSURE = 23;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_PRESSURE = 23,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_RETURN_TEMP = 26;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_RETURN_TEMP = 26,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_RETURN_TEMP_REFERENCE = 33896;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_RETURN_TEMP_REFERENCE = 33896,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_ROOM_LIST = 32952;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_ROOM_LIST = 32952,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_CAPABILITIES_MASK = 333;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_CAPABILITIES_MASK = 333,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_DEMAND = 168;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_DEMAND = 168,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_DEMAND_DEPRECATED = 104;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_DEMAND_DEPRECATED = 104,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_INLET_TEMP = 21;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_INLET_TEMP = 21,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_RETURN_TEMP = 22;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_RETURN_TEMP = 22,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_STATUS = 169;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_STATUS = 169,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_SUPPLIER_OID = 33036;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_SOURCE_SUPPLIER_OID = 33036,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_DISTRIBUTION_STATUS = 164;
   */
  VID_HEATING_COOLING_WATER_DISTRIBUTION_STATUS = 164,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_INLET_TEMP = 33031;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_INLET_TEMP = 33031,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_OUTDOOR_TEMP = 33033;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_OUTDOOR_TEMP = 33033,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_ROOM_TEMP = 33032;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_DESIGN_ROOM_TEMP = 33032,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_INLET_TEMP_MAX = 33027;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_INLET_TEMP_MAX = 33027,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_INLET_TEMP_MIN = 33026;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_INLET_TEMP_MIN = 33026,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_MANUAL = 33029;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_MANUAL = 33029,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_NO_THERMOSTAT_GAIN = 33034;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_NO_THERMOSTAT_GAIN = 33034,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_PARALEL_DISPLACEMENT = 33030;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_PARALEL_DISPLACEMENT = 33030,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_INLET_TEMP_MAX_DEFAULT = 34090;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_INLET_TEMP_MAX_DEFAULT = 34090,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_INLET_TEMP_MIN_DEFAULT = 34089;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_INLET_TEMP_MIN_DEFAULT = 34089,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_SLOPE_DEFAULT = 34088;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_RADIATOR_SLOPE_DEFAULT = 34088,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_SLOPE = 86;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_SLOPE = 86,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_TYPE = 33028;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_TYPE = 33028,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_INLET_TEMP_MAX_DEFAULT = 34093;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_INLET_TEMP_MAX_DEFAULT = 34093,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_INLET_TEMP_MIN_DEFAULT = 34092;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_INLET_TEMP_MIN_DEFAULT = 34092,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_SLOPE_DEFAULT = 34091;
   */
  VID_HEATING_COOLING_WATER_HEAT_CURVE_UNDERFLOOR_SLOPE_DEFAULT = 34091,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_COOLING_DESIRED_INLET_TEMPERATURE = 34054;
   */
  VID_HEATING_COOLING_WATER_SOURCE_COOLING_DESIRED_INLET_TEMPERATURE = 34054,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_DEMAND_LIMITER = 299;
   */
  VID_HEATING_COOLING_WATER_SOURCE_DEMAND_LIMITER = 299,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ANALOG_DEMAND = 165;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ANALOG_DEMAND = 165,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ANALOG_DEMAND_MODE = 34058;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ANALOG_DEMAND_MODE = 34058,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BINARY_DEMAND = 166;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BINARY_DEMAND = 166,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK = 34068;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK = 34068,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_DEMAND = 301;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_DEMAND = 301,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_MODE = 34067;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_MODE = 34067,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_PRIORITY_TEMPERATURE_SENSOR = 34049;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_CHARGE_PRIORITY_TEMPERATURE_SENSOR = 34049,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_LOWER_TEMPERATURE_SENSOR_ERROR = 16504;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_LOWER_TEMPERATURE_SENSOR_ERROR = 16504,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_PRIORITY_TEMPERATURE_SENSOR_ERROR = 16505;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_PRIORITY_TEMPERATURE_SENSOR_ERROR = 16505,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_UPPER_TEMPERATURE_SENSOR_ERROR = 16503;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_ERROR_TANK_UPPER_TEMPERATURE_SENSOR_ERROR = 16503,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_ENABLE = 34059;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_ENABLE = 34059,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_CAP = 34063;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_CAP = 34063,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_COEFFICIENT = 34061;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_COEFFICIENT = 34061,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_INTERVAL = 34062;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_I_INTERVAL = 34062,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_PROTECTION_INTERVAL_SECONDS = 34065;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_PROTECTION_INTERVAL_SECONDS = 34065,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_P_COEFFICIENT = 34060;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_P_COEFFICIENT = 34060,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_RESET_INTERVAL_SECONDS = 34064;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_FLOW_BALANCING_RESET_INTERVAL_SECONDS = 34064,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_START_CHARGING_DIFFERENCE_K = 34047;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_START_CHARGING_DIFFERENCE_K = 34047,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_STOP_CHARGING_DIFFERENCE_K = 34048;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_STOP_CHARGING_DIFFERENCE_K = 34048,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_LOWER_TEMP = 290;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_LOWER_TEMP = 290,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_LOWER_TEMP_REFERENCE = 34052;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_LOWER_TEMP_REFERENCE = 34052,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_UPPER_TEMP = 289;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_UPPER_TEMP = 289,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_UPPER_TEMP_REFERENCE = 34051;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_BUFFER_TANK_TANK_UPPER_TEMP_REFERENCE = 34051,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_NO_DEMAND_THRESHOLD = 33872;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_NO_DEMAND_THRESHOLD = 33872,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P1_TEMPERATURE = 33869;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P1_TEMPERATURE = 33869,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P1_VOLTAGE = 33868;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P1_VOLTAGE = 33868,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P2_TEMPERATURE = 33871;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P2_TEMPERATURE = 33871,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P2_VOLTAGE = 33870;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_ANALOG_CURVE_P2_VOLTAGE = 33870,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_DEMAND_BINARY = 288;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_COOLING_DEMAND_BINARY = 288,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_DEMAND_COOLDOWN_TIME_MINUTES = 33873;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_DEMAND_COOLDOWN_TIME_MINUTES = 33873,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_DEMAND_MINIMUM_TIME_MINUTES = 34046;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_DEMAND_MINIMUM_TIME_MINUTES = 34046,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_CAPABILITIES_MASK = 334;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_CAPABILITIES_MASK = 334,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_REQUEST_IN = 292;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_REQUEST_IN = 292,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_STATUS_OUT = 293;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ELEMENT_STATUS_OUT = 293,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ERROR_SOURCE_FAILURE = 16456;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ERROR_SOURCE_FAILURE = 16456,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ERROR_SOURCE_GENERAL_FAILURE = 16457;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_ERROR_SOURCE_GENERAL_FAILURE = 16457,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_NO_DEMAND_THRESHOLD = 33866;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_NO_DEMAND_THRESHOLD = 33866,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P1_TEMPERATURE = 33863;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P1_TEMPERATURE = 33863,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P1_VOLTAGE = 33862;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P1_VOLTAGE = 33862,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P2_TEMPERATURE = 33865;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P2_TEMPERATURE = 33865,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P2_VOLTAGE = 33864;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_ANALOG_CURVE_P2_VOLTAGE = 33864,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_DEMAND_BINARY = 287;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEATING_DEMAND_BINARY = 287,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_COMPRESSOR_STATUS = 317;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_COMPRESSOR_STATUS = 317,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_DEFROSTING_STATUS = 318;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_DEFROSTING_STATUS = 318,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_DHW_HEAT_STATUS = 324;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_DHW_HEAT_STATUS = 324,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_HEATER_OUTLET_TEMPERATURE = 320;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_HEATER_OUTLET_TEMPERATURE = 320,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_HEAT_PUMP_OUTLET_TEMPERATURE = 321;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_HEAT_PUMP_OUTLET_TEMPERATURE = 321,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_OUTDOOR_UNIT_STATUS = 319;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_OUTDOOR_UNIT_STATUS = 319,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_REFRIGERANT_TEMPERATURE = 323;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_REFRIGERANT_TEMPERATURE = 323,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_SILENT_MODE_STATUS = 325;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_HEAT_PUMP_SILENT_MODE_STATUS = 325,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_LAST_ACTIVITY = 170;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_LAST_ACTIVITY = 170,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_PRIORITY_COST = 34050;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_PRIORITY_COST = 34050,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_RELEASE_OUTDOOR_TEMPERATURE = 33876;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_RELEASE_OUTDOOR_TEMPERATURE = 33876,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_RELEASE = 167;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_RELEASE = 167,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_START_DELAY_MINUTES = 33874;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_START_DELAY_MINUTES = 33874,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_STOP_DELAY_MINUTES = 33875;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_SOURCE_STOP_DELAY_MINUTES = 33875,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_UN_RELEASE_OUTDOOR_TEMPERATURE = 33877;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_UN_RELEASE_OUTDOOR_TEMPERATURE = 33877,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_COOLING_DEMAND = 34056;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_COOLING_DEMAND = 34056,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_HEATING_DEMAND = 34055;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_HEATING_DEMAND = 34055,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_NO_DEMAND = 34057;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ELEMENT_VOLTAGE_NO_DEMAND = 34057,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_ERROR_INLET_TEMPERATURE_SENSOR_FAILURE = 16455;
   */
  VID_HEATING_COOLING_WATER_SOURCE_ERROR_INLET_TEMPERATURE_SENSOR_FAILURE = 16455,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_HEATING_DESIRED_INLET_TEMPERATURE = 34053;
   */
  VID_HEATING_COOLING_WATER_SOURCE_HEATING_DESIRED_INLET_TEMPERATURE = 34053,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_INLET_TEMPERATURE_SOURCE = 33878;
   */
  VID_HEATING_COOLING_WATER_SOURCE_INLET_TEMPERATURE_SOURCE = 33878,

  /**
   * @generated from enum value: VID_HEATING_COOLING_WATER_SOURCE_SOURCE_ELEMENT_LIST = 33867;
   */
  VID_HEATING_COOLING_WATER_SOURCE_SOURCE_ELEMENT_LIST = 33867,

  /**
   * @generated from enum value: VID_INPUT_OUTPUT_OBJECT_MODE = 33021;
   */
  VID_INPUT_OUTPUT_OBJECT_MODE = 33021,

  /**
   * @generated from enum value: VID_INPUT_OWNER_OID_DEPRECATED = 171;
   */
  VID_INPUT_OWNER_OID_DEPRECATED = 171,

  /**
   * @generated from enum value: VID_INPUT_OWNER_REFERENCE = 295;
   */
  VID_INPUT_OWNER_REFERENCE = 295,

  /**
   * @generated from enum value: VID_INPUT_VALUE_OVERRIDE_NON_PERSISTENT = 291;
   */
  VID_INPUT_VALUE_OVERRIDE_NON_PERSISTENT = 291,

  /**
   * @generated from enum value: VID_INPUT_VALUE_OVERRIDE_PERSISTENT = 33094;
   */
  VID_INPUT_VALUE_OVERRIDE_PERSISTENT = 33094,

  /**
   * @generated from enum value: VID_INTERFACE_ERROR_POWER_SHORTED = 16412;
   */
  VID_INTERFACE_ERROR_POWER_SHORTED = 16412,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_COOLING_INLET_TEMP_MAX = 33902;
   */
  VID_ITC_COOLING_CONTROLLER_COOLING_INLET_TEMP_MAX = 33902,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_COOLING_INLET_TEMP_MIN = 33901;
   */
  VID_ITC_COOLING_CONTROLLER_COOLING_INLET_TEMP_MIN = 33901,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_HYSTERESIS = 33900;
   */
  VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_HYSTERESIS = 33900,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_I_TIME = 33899;
   */
  VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_I_TIME = 33899,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_P_GAIN = 33898;
   */
  VID_ITC_COOLING_CONTROLLER_COOLING_REGULATOR_P_GAIN = 33898,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_DESIRED_SOURCE_WATER_TEMPERATURE = 58;
   */
  VID_ITC_COOLING_CONTROLLER_DESIRED_SOURCE_WATER_TEMPERATURE = 58,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_FROST_PROTECTION_TEMP = 32982;
   */
  VID_ITC_COOLING_CONTROLLER_FROST_PROTECTION_TEMP = 32982,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_HOTC_TEMP = 32963;
   */
  VID_ITC_COOLING_CONTROLLER_HOTC_TEMP = 32963,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_ITC_AUTO_REDUCTION_MODE = 32869;
   */
  VID_ITC_COOLING_CONTROLLER_ITC_AUTO_REDUCTION_MODE = 32869,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_ITC_AUTO_REDUCTION_TEMP = 32989;
   */
  VID_ITC_COOLING_CONTROLLER_ITC_AUTO_REDUCTION_TEMP = 32989,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_ITC_OUTDOOR_FILTER_SUPPRESSION = 32986;
   */
  VID_ITC_COOLING_CONTROLLER_ITC_OUTDOOR_FILTER_SUPPRESSION = 32986,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_ITC_TEMP_SET_MANUAL = 32866;
   */
  VID_ITC_COOLING_CONTROLLER_ITC_TEMP_SET_MANUAL = 32866,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_MODE = 32853;
   */
  VID_ITC_COOLING_CONTROLLER_MODE = 32853,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_PUMP_ACTIVATION_MODE = 32953;
   */
  VID_ITC_COOLING_CONTROLLER_PUMP_ACTIVATION_MODE = 32953,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_PUMP_ACTIVATION_TIME = 32955;
   */
  VID_ITC_COOLING_CONTROLLER_PUMP_ACTIVATION_TIME = 32955,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_PUMP_DELAYED_START = 32956;
   */
  VID_ITC_COOLING_CONTROLLER_PUMP_DELAYED_START = 32956,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_PUMP_DELAYED_STOP = 32957;
   */
  VID_ITC_COOLING_CONTROLLER_PUMP_DELAYED_STOP = 32957,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_PUMP_IDDLE_TIME = 32954;
   */
  VID_ITC_COOLING_CONTROLLER_PUMP_IDDLE_TIME = 32954,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_REQUIRED_COOL_SOURCE_TEMP_OFFSET = 33903;
   */
  VID_ITC_COOLING_CONTROLLER_REQUIRED_COOL_SOURCE_TEMP_OFFSET = 33903,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_CYCLES = 32960;
   */
  VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_CYCLES = 32960,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_IDDLE_TIME = 32959;
   */
  VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_IDDLE_TIME = 32959,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_MODE = 32958;
   */
  VID_ITC_COOLING_CONTROLLER_VALVE_ACTIVATION_MODE = 32958,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_VALVE_STATUS = 64;
   */
  VID_ITC_COOLING_CONTROLLER_VALVE_STATUS = 64,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_WARNING_RETENTIVE_LOW_ENERGY_FOR_COOLING = 16397;
   */
  VID_ITC_COOLING_CONTROLLER_WARNING_RETENTIVE_LOW_ENERGY_FOR_COOLING = 16397,

  /**
   * @generated from enum value: VID_ITC_COOLING_CONTROLLER_WARNING_RETENTIVE_LOW_ENERGY_FOR_HEATING = 16396;
   */
  VID_ITC_COOLING_CONTROLLER_WARNING_RETENTIVE_LOW_ENERGY_FOR_HEATING = 16396,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_INLET_TEMP = 32965;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_INLET_TEMP = 32965,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_OUTDOOR_TEMP = 32967;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_OUTDOOR_TEMP = 32967,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_ROOM_TEMP = 32966;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_DESIGN_ROOM_TEMP = 32966,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_INLET_TEMP_MAX = 32868;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_INLET_TEMP_MAX = 32868,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_INLET_TEMP_MIN = 32867;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_INLET_TEMP_MIN = 32867,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_MANUAL = 32969;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_MANUAL = 32969,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_NO_THERMOSTAT_GAIN = 32964;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_NO_THERMOSTAT_GAIN = 32964,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_PARALEL_DISPLACEMENT = 32870;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_PARALEL_DISPLACEMENT = 32870,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_SLOPE = 61;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_SLOPE = 61,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_CURVE_TYPE = 32968;
   */
  VID_ITC_HEATING_CONTROLLER_CURVE_TYPE = 32968,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_FROST_PROTECTION_MODE = 32981;
   */
  VID_ITC_HEATING_CONTROLLER_FROST_PROTECTION_MODE = 32981,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_HTCO_ALARM = 16398;
   */
  VID_ITC_HEATING_CONTROLLER_HTCO_ALARM = 16398,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_HTCO_INTEGRATION_THRESHOLD = 33905;
   */
  VID_ITC_HEATING_CONTROLLER_HTCO_INTEGRATION_THRESHOLD = 33905,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_HTCO_MODE = 32855;
   */
  VID_ITC_HEATING_CONTROLLER_HTCO_MODE = 32855,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_HTCO_TEMP = 32857;
   */
  VID_ITC_HEATING_CONTROLLER_HTCO_TEMP = 32857,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_BOOST_LEVEL = 32976;
   */
  VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_BOOST_LEVEL = 32976,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_BOOST_MODE = 32975;
   */
  VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_BOOST_MODE = 32975,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_RAMPING_MODE = 32977;
   */
  VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_RAMPING_MODE = 32977,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_RAMPING_TIME_MINUTES = 32978;
   */
  VID_ITC_HEATING_CONTROLLER_OPTIMIZATION_RAMPING_TIME_MINUTES = 32978,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_REGULATOR_HYSTERESIS = 32985;
   */
  VID_ITC_HEATING_CONTROLLER_REGULATOR_HYSTERESIS = 32985,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_REGULATOR_I_TIME = 32984;
   */
  VID_ITC_HEATING_CONTROLLER_REGULATOR_I_TIME = 32984,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_REGULATOR_MODE = 32863;
   */
  VID_ITC_HEATING_CONTROLLER_REGULATOR_MODE = 32863,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_REGULATOR_P_GAIN = 32983;
   */
  VID_ITC_HEATING_CONTROLLER_REGULATOR_P_GAIN = 32983,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_REQUIRED_HEAT_SOURCE_TEMP_OFFSET = 32962;
   */
  VID_ITC_HEATING_CONTROLLER_REQUIRED_HEAT_SOURCE_TEMP_OFFSET = 32962,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_LIMITER_MODE = 32970;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_LIMITER_MODE = 32970,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_GAIN = 32973;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_GAIN = 32973,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_LIMIT = 32971;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_LIMIT = 32971,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_PRIORITY = 32987;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MAX_LIMITER_PRIORITY = 32987,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MIN_LIMITER_GAIN = 32974;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MIN_LIMITER_GAIN = 32974,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MIN_LIMITER_LIMIT = 32972;
   */
  VID_ITC_HEATING_CONTROLLER_RETURN_TEMP_MIN_LIMITER_LIMIT = 32972,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_ROOM_CORRECTION_MAX_GAIN = 32979;
   */
  VID_ITC_HEATING_CONTROLLER_ROOM_CORRECTION_MAX_GAIN = 32979,

  /**
   * @generated from enum value: VID_ITC_HEATING_CONTROLLER_ROOM_CORRECTION_MIN_GAIN = 32980;
   */
  VID_ITC_HEATING_CONTROLLER_ROOM_CORRECTION_MIN_GAIN = 32980,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ASSOCIATED_PUMP_OUTPUT = 33897;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ASSOCIATED_PUMP_OUTPUT = 33897,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_DESIRED_INLET_TEMP = 59;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_DESIRED_INLET_TEMP = 59,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_DESIRED_ROOM_TEMP_BY_CONSUMERS = 41;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_DESIRED_ROOM_TEMP_BY_CONSUMERS = 41,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_FROST_PROTECTION_ACTIVE = 16434;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_FROST_PROTECTION_ACTIVE = 16434,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_INLET_SENSOR_FAILURE = 16429;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_INLET_SENSOR_FAILURE = 16429,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_OUTDOOR_SENSOR_FAILURE = 16432;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_OUTDOOR_SENSOR_FAILURE = 16432,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_REGULATOR_FAILURE = 16407;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_REGULATOR_FAILURE = 16407,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_RETURN_SENSOR_FAILURE = 16431;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_RETURN_SENSOR_FAILURE = 16431,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_SERVO_FAILURE = 16430;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_ERROR_SERVO_FAILURE = 16430,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_HEATING_COOLING_MODE = 32854;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_HEATING_COOLING_MODE = 32854,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_HEATING_SERIAL_MODE = 32961;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_HEATING_SERIAL_MODE = 32961,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_INLET_TEMP = 62;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_INLET_TEMP = 62,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_INLET_TEMP_REFERENCE = 33895;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_INLET_TEMP_REFERENCE = 33895,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_PUMP_DEMAND = 124;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_PUMP_DEMAND = 124,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_PUMP_STATUS = 65;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_PUMP_STATUS = 65,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_RETURN_TEMP = 63;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_RETURN_TEMP = 63,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_SERVO_REQUEST = 91;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_SERVO_REQUEST = 91,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_SOURCE_DEMAND = 57;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_SOURCE_DEMAND = 57,

  /**
   * @generated from enum value: VID_ITC_OBJECT_INLET_TEMP_CONTROL_WARNING_REGULATOR_FAILURE = 16408;
   */
  VID_ITC_OBJECT_INLET_TEMP_CONTROL_WARNING_REGULATOR_FAILURE = 16408,

  /**
   * @generated from enum value: VID_LOCATION_ALLOW_TEST_SUPPORT_MODE = 33095;
   */
  VID_LOCATION_ALLOW_TEST_SUPPORT_MODE = 33095,

  /**
   * @generated from enum value: VID_LOCATION_ALLOW_UNDER_DEVELOPMENT_FEATURES = 33091;
   */
  VID_LOCATION_ALLOW_UNDER_DEVELOPMENT_FEATURES = 33091,

  /**
   * @generated from enum value: VID_LOCATION_BACKUP = 81;
   */
  VID_LOCATION_BACKUP = 81,

  /**
   * @generated from enum value: VID_LOCATION_BEHAVIOUR_VARIANT = 256;
   */
  VID_LOCATION_BEHAVIOUR_VARIANT = 256,

  /**
   * @generated from enum value: VID_LOCATION_COMMAND = 66;
   */
  VID_LOCATION_COMMAND = 66,

  /**
   * @generated from enum value: VID_LOCATION_DEBUG_LEVEL = 33930;
   */
  VID_LOCATION_DEBUG_LEVEL = 33930,

  /**
   * @generated from enum value: VID_LOCATION_DEFAULT_LANGUAGE = 255;
   */
  VID_LOCATION_DEFAULT_LANGUAGE = 255,

  /**
   * @generated from enum value: VID_LOCATION_EMULATE_FAIL = 18;
   */
  VID_LOCATION_EMULATE_FAIL = 18,

  /**
   * @generated from enum value: VID_LOCATION_EXERCISING_LAST_ACTIVATION = 33929;
   */
  VID_LOCATION_EXERCISING_LAST_ACTIVATION = 33929,

  /**
   * @generated from enum value: VID_LOCATION_EXERCISING_SCHEDULE = 33928;
   */
  VID_LOCATION_EXERCISING_SCHEDULE = 33928,

  /**
   * @generated from enum value: VID_LOCATION_EXERCISING_SCHEDULE_OVERRIDE = 189;
   */
  VID_LOCATION_EXERCISING_SCHEDULE_OVERRIDE = 189,

  /**
   * @generated from enum value: VID_LOCATION_EXERCISING_SCHEDULE_OVERRIDE_SETUP = 242;
   */
  VID_LOCATION_EXERCISING_SCHEDULE_OVERRIDE_SETUP = 242,

  /**
   * @generated from enum value: VID_LOCATION_FROST_PROTECTION_INLET_TEMPERATURE_THRESHOLD = 33086;
   */
  VID_LOCATION_FROST_PROTECTION_INLET_TEMPERATURE_THRESHOLD = 33086,

  /**
   * @generated from enum value: VID_LOCATION_FROST_PROTECTION_OUTDOOR_TEMPERATURE_THRESHOLD = 33087;
   */
  VID_LOCATION_FROST_PROTECTION_OUTDOOR_TEMPERATURE_THRESHOLD = 33087,

  /**
   * @generated from enum value: VID_LOCATION_FROST_PROTECTION_ROOM_TEMPERATURE_THRESHOLD = 33085;
   */
  VID_LOCATION_FROST_PROTECTION_ROOM_TEMPERATURE_THRESHOLD = 33085,

  /**
   * @generated from enum value: VID_LOCATION_GLOBAL_SILENT_MODE = 34100;
   */
  VID_LOCATION_GLOBAL_SILENT_MODE = 34100,

  /**
   * @generated from enum value: VID_LOCATION_GSM_LOCATION = 45;
   */
  VID_LOCATION_GSM_LOCATION = 45,

  /**
   * @generated from enum value: VID_LOCATION_HARDWARE_PROFILE = 33000;
   */
  VID_LOCATION_HARDWARE_PROFILE = 33000,

  /**
   * @generated from enum value: VID_LOCATION_LEARN_DESTINATION_OID = 32940;
   */
  VID_LOCATION_LEARN_DESTINATION_OID = 32940,

  /**
   * @generated from enum value: VID_LOCATION_LEARN_PERIPH_OID = 32941;
   */
  VID_LOCATION_LEARN_PERIPH_OID = 32941,

  /**
   * @generated from enum value: VID_LOCATION_LICENSE = 32881;
   */
  VID_LOCATION_LICENSE = 32881,

  /**
   * @generated from enum value: VID_LOCATION_LICENSE_END = 32882;
   */
  VID_LOCATION_LICENSE_END = 32882,

  /**
   * @generated from enum value: VID_LOCATION_NEW_HARDWARE_PROFILE = 33006;
   */
  VID_LOCATION_NEW_HARDWARE_PROFILE = 33006,

  /**
   * @generated from enum value: VID_LOCATION_OUTDOOR_TEMPERATURE_FILTER_SETTINGS = 34029;
   */
  VID_LOCATION_OUTDOOR_TEMPERATURE_FILTER_SETTINGS = 34029,

  /**
   * @generated from enum value: VID_LOCATION_OUTDOOR_TEMPERATURE_SOURCE = 33894;
   */
  VID_LOCATION_OUTDOOR_TEMPERATURE_SOURCE = 33894,

  /**
   * @generated from enum value: VID_LOCATION_OUTDOOR_TEMPERATURE_SOURCE_DEPRECATED = 33007;
   */
  VID_LOCATION_OUTDOOR_TEMPERATURE_SOURCE_DEPRECATED = 33007,

  /**
   * @generated from enum value: VID_LOCATION_RECYCLE_BIN = 32998;
   */
  VID_LOCATION_RECYCLE_BIN = 32998,

  /**
   * @generated from enum value: VID_LOCATION_REPUBLISH_PERIOD_TIME = 33861;
   */
  VID_LOCATION_REPUBLISH_PERIOD_TIME = 33861,

  /**
   * @generated from enum value: VID_LOCATION_RESTORE = 82;
   */
  VID_LOCATION_RESTORE = 82,

  /**
   * @generated from enum value: VID_LOCATION_SERVICE_KEY_WRITE_ONLY_DEPRECATED = 111;
   */
  VID_LOCATION_SERVICE_KEY_WRITE_ONLY_DEPRECATED = 111,

  /**
   * @generated from enum value: VID_LOCATION_SERVICE_MODE_END_TIME = 33061;
   */
  VID_LOCATION_SERVICE_MODE_END_TIME = 33061,

  /**
   * @generated from enum value: VID_LOCATION_SILENT_MODE_ACTIVE = 340;
   */
  VID_LOCATION_SILENT_MODE_ACTIVE = 340,

  /**
   * @generated from enum value: VID_LOCATION_STRUCTURE_ID = 33010;
   */
  VID_LOCATION_STRUCTURE_ID = 33010,

  /**
   * @generated from enum value: VID_LOCATION_SUPPORT_MODE = 32864;
   */
  VID_LOCATION_SUPPORT_MODE = 32864,

  /**
   * @generated from enum value: VID_LOCATION_WARNING_DEV_SERVICE = 16403;
   */
  VID_LOCATION_WARNING_DEV_SERVICE = 16403,

  /**
   * @generated from enum value: VID_LOCATION_WARNING_FAULT = 16404;
   */
  VID_LOCATION_WARNING_FAULT = 16404,

  /**
   * @generated from enum value: VID_LOCATION_WARN_MAINTENANCE = 16464;
   */
  VID_LOCATION_WARN_MAINTENANCE = 16464,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_BAUDRATE = 32823;
   */
  VID_MODBUS_MODBUS_BAUDRATE = 32823,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_MODE = 32821;
   */
  VID_MODBUS_MODBUS_MODE = 32821,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_PARITY = 33824;
   */
  VID_MODBUS_MODBUS_PARITY = 33824,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_SLAVE_ADDR = 32822;
   */
  VID_MODBUS_MODBUS_SLAVE_ADDR = 32822,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_SLAVE_PASSWORD = 33099;
   */
  VID_MODBUS_MODBUS_SLAVE_PASSWORD = 33099,

  /**
   * @generated from enum value: VID_MODBUS_MODBUS_STOP_BITS = 33825;
   */
  VID_MODBUS_MODBUS_STOP_BITS = 33825,

  /**
   * @generated from enum value: VID_NETWORKING_DNS_IP_ADDRESS = 185;
   */
  VID_NETWORKING_DNS_IP_ADDRESS = 185,

  /**
   * @generated from enum value: VID_NETWORKING_IP_ADDRESS_DEPRECATED = 114;
   */
  VID_NETWORKING_IP_ADDRESS_DEPRECATED = 114,

  /**
   * @generated from enum value: VID_NETWORKING_STATE = 172;
   */
  VID_NETWORKING_STATE = 172,

  /**
   * @generated from enum value: VID_NETWORKING_STATIC_DNS_IP_ADDRESS = 33912;
   */
  VID_NETWORKING_STATIC_DNS_IP_ADDRESS = 33912,

  /**
   * @generated from enum value: VID_OPENTHERM_HEATING_REQUEST = 266;
   */
  VID_OPENTHERM_HEATING_REQUEST = 266,

  /**
   * @generated from enum value: VID_OPENTHERM_STATE = 260;
   */
  VID_OPENTHERM_STATE = 260,

  /**
   * @generated from enum value: VID_OUTDOOR_ZONE_ERROR_GENERAL_PROBLEM = 16444;
   */
  VID_OUTDOOR_ZONE_ERROR_GENERAL_PROBLEM = 16444,

  /**
   * @generated from enum value: VID_OUTDOOR_ZONE_OUTDOOR_TEMPERATURE_BMS_OVERRIDE = 33090;
   */
  VID_OUTDOOR_ZONE_OUTDOOR_TEMPERATURE_BMS_OVERRIDE = 33090,

  /**
   * @generated from enum value: VID_OUTDOOR_ZONE_WARNING_PERIPHERAL_LOW_BATERY = 16445;
   */
  VID_OUTDOOR_ZONE_WARNING_PERIPHERAL_LOW_BATERY = 16445,

  /**
   * @generated from enum value: VID_OUTDOOR_ZONE_WARNING_PERIPHERAL_UNREACHABLE = 16446;
   */
  VID_OUTDOOR_ZONE_WARNING_PERIPHERAL_UNREACHABLE = 16446,

  /**
   * @generated from enum value: VID_OUTPUT_ALARM_OUTPUT_FAIL = 16405;
   */
  VID_OUTPUT_ALARM_OUTPUT_FAIL = 16405,

  /**
   * @generated from enum value: VID_OUTPUT_BLOCK_SOURCE = 32937;
   */
  VID_OUTPUT_BLOCK_SOURCE = 32937,

  /**
   * @generated from enum value: VID_OUTPUT_BLOCK_THRESHOLD = 33009;
   */
  VID_OUTPUT_BLOCK_THRESHOLD = 33009,

  /**
   * @generated from enum value: VID_OUTPUT_DELAY_END = 32936;
   */
  VID_OUTPUT_DELAY_END = 32936,

  /**
   * @generated from enum value: VID_OUTPUT_DELAY_START = 32935;
   */
  VID_OUTPUT_DELAY_START = 32935,

  /**
   * @generated from enum value: VID_OUTPUT_ERROR_INVALID_REFERENCE = 16453;
   */
  VID_OUTPUT_ERROR_INVALID_REFERENCE = 16453,

  /**
   * @generated from enum value: VID_OUTPUT_EXERCISE_BLOCKED = 125;
   */
  VID_OUTPUT_EXERCISE_BLOCKED = 125,

  /**
   * @generated from enum value: VID_OUTPUT_EXERCISE_CYCLE_LENGTH = 33042;
   */
  VID_OUTPUT_EXERCISE_CYCLE_LENGTH = 33042,

  /**
   * @generated from enum value: VID_OUTPUT_EXERCISE_ENABLED = 33041;
   */
  VID_OUTPUT_EXERCISE_ENABLED = 33041,

  /**
   * @generated from enum value: VID_OUTPUT_EXERCISE_IDLE_TIME_DAYS = 33040;
   */
  VID_OUTPUT_EXERCISE_IDLE_TIME_DAYS = 33040,

  /**
   * @generated from enum value: VID_OUTPUT_EXERCISE_STATUS = 93;
   */
  VID_OUTPUT_EXERCISE_STATUS = 93,

  /**
   * @generated from enum value: VID_OUTPUT_INDICATION_OVERRIDE = 188;
   */
  VID_OUTPUT_INDICATION_OVERRIDE = 188,

  /**
   * @generated from enum value: VID_OUTPUT_INVERTED = 32938;
   */
  VID_OUTPUT_INVERTED = 32938,

  /**
   * @generated from enum value: VID_OUTPUT_LAST_ACTIVATION = 33925;
   */
  VID_OUTPUT_LAST_ACTIVATION = 33925,

  /**
   * @generated from enum value: VID_OUTPUT_LAST_ACTIVATION_NON_PERSISTENT_DEPRECATED = 92;
   */
  VID_OUTPUT_LAST_ACTIVATION_NON_PERSISTENT_DEPRECATED = 92,

  /**
   * @generated from enum value: VID_OUTPUT_SERVICE_MODE_DEPRECATED = 32933;
   */
  VID_OUTPUT_SERVICE_MODE_DEPRECATED = 32933,

  /**
   * @generated from enum value: VID_OUTPUT_SERVICE_MODE_END_TIME = 33065;
   */
  VID_OUTPUT_SERVICE_MODE_END_TIME = 33065,

  /**
   * @generated from enum value: VID_OUTPUT_SERVICE_VALUE = 32934;
   */
  VID_OUTPUT_SERVICE_VALUE = 32934,

  /**
   * @generated from enum value: VID_OUTPUT_SOURCE_MAX_VALUE = 32930;
   */
  VID_OUTPUT_SOURCE_MAX_VALUE = 32930,

  /**
   * @generated from enum value: VID_OUTPUT_SOURCE_MIN_VALUE = 32929;
   */
  VID_OUTPUT_SOURCE_MIN_VALUE = 32929,

  /**
   * @generated from enum value: VID_OUTPUT_VALUE_SOURCE = 32928;
   */
  VID_OUTPUT_VALUE_SOURCE = 32928,

  /**
   * @generated from enum value: VID_OUTPUT_VALUE_THRESHOLD = 32931;
   */
  VID_OUTPUT_VALUE_THRESHOLD = 32931,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_ACTUAL_CURRENT = 80;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_ACTUAL_CURRENT = 80,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_DYNAMIC_CURRENT_MAX = 77;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_DYNAMIC_CURRENT_MAX = 77,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_DYNAMIC_CURRENT_MIN = 78;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_DYNAMIC_CURRENT_MIN = 78,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_GRANTED_CURRENT = 79;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_GRANTED_CURRENT = 79,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_POWER_CONSUMERS_LIST = 90;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_POWER_CONSUMERS_LIST = 90,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_POWER_PRIORITY = 32951;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_POWER_PRIORITY = 32951,

  /**
   * @generated from enum value: VID_POWER_MANAGEMENT_CONTROLLER_STATIC_CURRENT = 32946;
   */
  VID_POWER_MANAGEMENT_CONTROLLER_STATIC_CURRENT = 32946,

  /**
   * @generated from enum value: VID_PRESET_FUNCTION_CONFIGURATION_ASSOCIATED_MAP_INDEX = 33828;
   */
  VID_PRESET_FUNCTION_CONFIGURATION_ASSOCIATED_MAP_INDEX = 33828,

  /**
   * @generated from enum value: VID_PRESET_FUNCTION_CONFIGURATION_ASSOCIATED_MAP_INDEX_OFFSET = 33829;
   */
  VID_PRESET_FUNCTION_CONFIGURATION_ASSOCIATED_MAP_INDEX_OFFSET = 33829,

  /**
   * @generated from enum value: VID_PROFILE_CURRENT_PRESET_FUNCTION_ASSIGNMENT_MAP = 33892;
   */
  VID_PROFILE_CURRENT_PRESET_FUNCTION_ASSIGNMENT_MAP = 33892,

  /**
   * @generated from enum value: VID_PROFILE_ERROR_PROFILE_CONDITIONS_NOT_MET = 16458;
   */
  VID_PROFILE_ERROR_PROFILE_CONDITIONS_NOT_MET = 16458,

  /**
   * @generated from enum value: VID_PROFILE_PRESET_FUNCTION_ASSIGNMENT_MAP = 33827;
   */
  VID_PROFILE_PRESET_FUNCTION_ASSIGNMENT_MAP = 33827,

  /**
   * @generated from enum value: VID_PROFILE_PROFILE_NAME = 33826;
   */
  VID_PROFILE_PROFILE_NAME = 33826,

  /**
   * @generated from enum value: VID_RESOURCES_CMV_BLOCKS_REMAINING = 224;
   */
  VID_RESOURCES_CMV_BLOCKS_REMAINING = 224,

  /**
   * @generated from enum value: VID_RESOURCES_DEHUMIDIFIER_BLOCKS_REMAINING = 141;
   */
  VID_RESOURCES_DEHUMIDIFIER_BLOCKS_REMAINING = 141,

  /**
   * @generated from enum value: VID_RESOURCES_DHW_TANK_BLOCKS_REMAINING = 140;
   */
  VID_RESOURCES_DHW_TANK_BLOCKS_REMAINING = 140,

  /**
   * @generated from enum value: VID_RESOURCES_DRYING_BLOCKS_REMAINING = 155;
   */
  VID_RESOURCES_DRYING_BLOCKS_REMAINING = 155,

  /**
   * @generated from enum value: VID_RESOURCES_HCC_BLOCKS_REMAINING = 139;
   */
  VID_RESOURCES_HCC_BLOCKS_REMAINING = 139,

  /**
   * @generated from enum value: VID_RESOURCES_HP_BUFFER_TANK_BLOCKS_REMAINING = 294;
   */
  VID_RESOURCES_HP_BUFFER_TANK_BLOCKS_REMAINING = 294,

  /**
   * @generated from enum value: VID_RESOURCES_HP_HCWS_ELEMENT_BLOCKS_AVAILABLE = 303;
   */
  VID_RESOURCES_HP_HCWS_ELEMENT_BLOCKS_AVAILABLE = 303,

  /**
   * @generated from enum value: VID_RESOURCES_INTEGRATION_BLOCKS_REMAINING = 156;
   */
  VID_RESOURCES_INTEGRATION_BLOCKS_REMAINING = 156,

  /**
   * @generated from enum value: VID_RESOURCES_ITC_BLOCKS_REMAINING = 138;
   */
  VID_RESOURCES_ITC_BLOCKS_REMAINING = 138,

  /**
   * @generated from enum value: VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_CMV_FUNCTION_POOL_ALLOCATION_INTERNAL = 33958;
   */
  VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_CMV_FUNCTION_POOL_ALLOCATION_INTERNAL = 33958,

  /**
   * @generated from enum value: VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_DEHUMIDIFIERS_POOL_ALLOCATION_INTERNAL = 33840;
   */
  VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_DEHUMIDIFIERS_POOL_ALLOCATION_INTERNAL = 33840,

  /**
   * @generated from enum value: VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_DRYING_FUNCTION_POOL_ALLOCATION_INTERNAL = 33841;
   */
  VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_DRYING_FUNCTION_POOL_ALLOCATION_INTERNAL = 33841,

  /**
   * @generated from enum value: VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_HCC_FUNCTION_POOL_ALLOCATION_INTERNAL = 33891;
   */
  VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_HCC_FUNCTION_POOL_ALLOCATION_INTERNAL = 33891,

  /**
   * @generated from enum value: VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_INTEGRATION_FUNCTION_POOL_ALLOCATION_INTERNAL = 33842;
   */
  VID_RESOURCE_ALLOCATION_DATA_STRUCTURES_INTEGRATION_FUNCTION_POOL_ALLOCATION_INTERNAL = 33842,

  /**
   * @generated from enum value: VID_ROOM_CO2_CONTROLLER_BLOCKING = 33;
   */
  VID_ROOM_CO2_CONTROLLER_BLOCKING = 33,

  /**
   * @generated from enum value: VID_ROOM_CO2_CONTROLLER_CO2_WARNING_LEVEL = 32832;
   */
  VID_ROOM_CO2_CONTROLLER_CO2_WARNING_LEVEL = 32832,

  /**
   * @generated from enum value: VID_ROOM_CO2_CONTROLLER_STATE = 32;
   */
  VID_ROOM_CO2_CONTROLLER_STATE = 32,

  /**
   * @generated from enum value: VID_ROOM_CO2_CONTROLLER_WARNING_CO2_ABOVE_WARNING_LEVEL = 16392;
   */
  VID_ROOM_CO2_CONTROLLER_WARNING_CO2_ABOVE_WARNING_LEVEL = 16392,

  /**
   * @generated from enum value: VID_ROOM_CO2_LEVEL = 49202;
   */
  VID_ROOM_CO2_LEVEL = 49202,

  /**
   * @generated from enum value: VID_ROOM_CO2_WARNING_LEVEL = 51258;
   */
  VID_ROOM_CO2_WARNING_LEVEL = 51258,

  /**
   * @generated from enum value: VID_ROOM_COOPERATION = 51251;
   */
  VID_ROOM_COOPERATION = 51251,

  /**
   * @generated from enum value: VID_ROOM_DRYER_BLOCKING = 31;
   */
  VID_ROOM_DRYER_BLOCKING = 31,

  /**
   * @generated from enum value: VID_ROOM_DRYER_STATE = 30;
   */
  VID_ROOM_DRYER_STATE = 30,

  /**
   * @generated from enum value: VID_ROOM_FEATURES = 49191;
   */
  VID_ROOM_FEATURES = 49191,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_ERROR_SUPPLIER_UNAVAILABLE = 16508;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_ERROR_SUPPLIER_UNAVAILABLE = 16508,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_SOURCE_DEMAND = 177;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_SOURCE_DEMAND = 177,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_SUPPLIER_OID = 33921;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_RADIATORS_SUPPLIER_OID = 33921,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_ERROR_SUPPLIER_UNAVAILABLE = 16509;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_ERROR_SUPPLIER_UNAVAILABLE = 16509,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_SOURCE_DEMAND = 178;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_SOURCE_DEMAND = 178,

  /**
   * @generated from enum value: VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_SUPPLIER_OID = 33922;
   */
  VID_ROOM_HEATING_COOLING_WATER_DISTRIBUTION_FOR_UFHC_SUPPLIER_OID = 33922,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_ALARM_HUMIDITY_HIGH = 16391;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_ALARM_HUMIDITY_HIGH = 16391,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_COOLING_DEW_POINT_THRESHOLD = 33856;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_COOLING_DEW_POINT_THRESHOLD = 33856,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_COOLING_DEW_POINT_THRESHOLD_HYSTERESIS = 33857;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_COOLING_DEW_POINT_THRESHOLD_HYSTERESIS = 33857,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_COOLING = 33850;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_COOLING = 33850,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_HEATING = 33844;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_HEATING = 33844,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_HYSTERESIS = 33847;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_DRYING_OFFSET_HYSTERESIS = 33847,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_ALARM_HIGH = 32828;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_ALARM_HIGH = 32828,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_ALARM_HYSTERESIS = 34074;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HUMIDITY_ALARM_HYSTERESIS = 34074,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_HYSTERESIS = 32827;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_HYSTERESIS = 32827,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_ENABLE = 34101;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_ENABLE = 34101,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_OFFSET = 34034;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_OFFSET = 34034,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_TIME_INTERVAL = 34035;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_NIGHT_SET_BACK_TIME_INTERVAL = 34035,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_PROGRAMMABLE_OUTPUT_LEVEL = 118;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_PROGRAMMABLE_OUTPUT_LEVEL = 118,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_CONTROLLER_THERMOSTAT_HUMIDITY_ADJUSTMENT_ENABLED = 34031;
   */
  VID_ROOM_HUMIDITY_CONTROLLER_THERMOSTAT_HUMIDITY_ADJUSTMENT_ENABLED = 34031,

  /**
   * @generated from enum value: VID_ROOM_HUMIDITY_DESIRED = 32826;
   */
  VID_ROOM_HUMIDITY_DESIRED = 32826,

  /**
   * @generated from enum value: VID_ROOM_MVDI_DEVICE_ID = 49174;
   */
  VID_ROOM_MVDI_DEVICE_ID = 49174,

  /**
   * @generated from enum value: VID_ROOM_AGGREGATED_NON_AUTONOMOUS_SRT_AIR_TEMP = 173;
   */
  VID_ROOM_AGGREGATED_NON_AUTONOMOUS_SRT_AIR_TEMP = 173,

  /**
   * @generated from enum value: VID_ROOM_ALARM_NO_TEMPERATURE_SOURCE = 16409;
   */
  VID_ROOM_ALARM_NO_TEMPERATURE_SOURCE = 16409,

  /**
   * @generated from enum value: VID_ROOM_ALARM_OUTPUT_FAIL = 16411;
   */
  VID_ROOM_ALARM_OUTPUT_FAIL = 16411,

  /**
   * @generated from enum value: VID_ROOM_ALARM_OUTPUT_LOST = 16410;
   */
  VID_ROOM_ALARM_OUTPUT_LOST = 16410,

  /**
   * @generated from enum value: VID_ROOM_COMFORT_LEVEL_DEPRECATED = 60;
   */
  VID_ROOM_COMFORT_LEVEL_DEPRECATED = 60,

  /**
   * @generated from enum value: VID_ROOM_CONTROLLER_CONFIGURATION_MASK = 34036;
   */
  VID_ROOM_CONTROLLER_CONFIGURATION_MASK = 34036,

  /**
   * @generated from enum value: VID_ROOM_HOTEL_RESET_TIME = 32775;
   */
  VID_ROOM_HOTEL_RESET_TIME = 32775,

  /**
   * @generated from enum value: VID_ROOM_MODE_OVERRIDE = 32773;
   */
  VID_ROOM_MODE_OVERRIDE = 32773,

  /**
   * @generated from enum value: VID_ROOM_MODE_OVERRIDE_END_TIME = 32774;
   */
  VID_ROOM_MODE_OVERRIDE_END_TIME = 32774,

  /**
   * @generated from enum value: VID_ROOM_OUTPUT_LIST = 32911;
   */
  VID_ROOM_OUTPUT_LIST = 32911,

  /**
   * @generated from enum value: VID_ROOM_WARNING_PERIPHERAL_LOW_BATERY = 16399;
   */
  VID_ROOM_WARNING_PERIPHERAL_LOW_BATERY = 16399,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_AGGREGATED_SRT_RADIATOR_DEMAND = 105;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_AGGREGATED_SRT_RADIATOR_DEMAND = 105,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_AGGREGATED_SRT_UFHC_DEMAND = 187;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_AGGREGATED_SRT_UFHC_DEMAND = 187,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_DEW_POINT_BLOCKING_INTEGRATION_THRESHOLD = 33904;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_DEW_POINT_BLOCKING_INTEGRATION_THRESHOLD = 33904,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_FLOOR_TEMP_HYSTERESIS = 33920;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_FLOOR_TEMP_HYSTERESIS = 33920,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_FLOOR_TEMP_LIMIT_MIN = 32824;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_FLOOR_TEMP_LIMIT_MIN = 32824,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_HYSTERESIS = 32820;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_HYSTERESIS = 32820,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_ADJUSTED_OVERRIDE = 32819;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_ADJUSTED_OVERRIDE = 32819,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_MANUAL = 32813;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_MANUAL = 32813,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_PARTY_OVERRIDE = 32817;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOLING_TEMP_SET_PARTY_OVERRIDE = 32817,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOPERATION_MODE = 33919;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOPERATION_MODE = 33919,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_COOPERATION_MODE_USED = 175;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_COOPERATION_MODE_USED = 175,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_ERROR_NO_UNDERFLOOR_OUTPUT = 16461;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_ERROR_NO_UNDERFLOOR_OUTPUT = 16461,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FEATURE_SET = 335;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FEATURE_SET = 335,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_BLOCKING = 157;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_BLOCKING = 157,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_PROPORTIONAL_LEVEL = 103;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_PROPORTIONAL_LEVEL = 103,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_SRT_CONTROL = 159;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_SRT_CONTROL = 159,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_STATE = 181;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_STATE = 181,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_VALVE_LEVEL = 56;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_FLOOR_VALVE_LEVEL = 56,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_ADAPTIVE_MODE_ENABLED = 32790;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_ADAPTIVE_MODE_ENABLED = 32790,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_ADAPTIVE_MODE_VALUES = 33923;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_ADAPTIVE_MODE_VALUES = 33923,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_COOPERATION_INCREASED_DEADBAND = 33918;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_COOPERATION_INCREASED_DEADBAND = 33918,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_COOPERATION_NORMAL_DEADBAND = 33917;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_COOPERATION_NORMAL_DEADBAND = 33917,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_HYSTERESIS = 32888;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_HYSTERESIS = 32888,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX = 32806;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX = 32806,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_COMFORT = 32896;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_COMFORT = 32896,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_ECO = 32889;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_ECO = 32889,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_EXTRA_COMFORT = 32897;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MAX_EXTRA_COMFORT = 32897,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN = 32932;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN = 32932,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_COMFORT = 32804;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_COMFORT = 32804,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_ECO = 32803;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_ECO = 32803,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_EXTRA_COMFORT = 32805;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_FLOOR_TEMP_LIMIT_MIN_EXTRA_COMFORT = 32805,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_HYSTERESIS = 32802;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_HYSTERESIS = 32802,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_ADJUSTED_OVERRIDE = 32800;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_ADJUSTED_OVERRIDE = 32800,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_MANUAL = 32794;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_MANUAL = 32794,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_PARTY_OVERRIDE = 32798;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_HEATING_TEMP_SET_PARTY_OVERRIDE = 32798,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_MODE_OVERRIDE = 34095;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_MODE_OVERRIDE = 34095,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_BAND_OFFSET = 33080;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_BAND_OFFSET = 33080,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_LEVEL_BAND = 33064;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_LEVEL_BAND = 33064,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_OUTPUT_OFFSET = 33083;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_PROPORTIONAL_OUTPUT_OFFSET = 33083,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_BLOCKING = 180;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_BLOCKING = 180,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_PROPORTIONAL_LEVEL = 108;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_PROPORTIONAL_LEVEL = 108,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_SRT_CONTROL = 160;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_SRT_CONTROL = 160,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_STATE = 179;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_STATE = 179,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_VALVE_LEVEL = 107;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_RADIATOR_VALVE_LEVEL = 107,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_DESIRED_FLOOR = 158;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_TEMP_DESIRED_FLOOR = 158,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_WARNING_RADIATORS_HAVE_NO_SUPPLIER = 16463;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_WARNING_RADIATORS_HAVE_NO_SUPPLIER = 16463,

  /**
   * @generated from enum value: VID_ROOM_TEMPERATURE_CONTROLLER_WARNING_UFHC_HAS_NO_SUPPLIER = 16462;
   */
  VID_ROOM_TEMPERATURE_CONTROLLER_WARNING_UFHC_HAS_NO_SUPPLIER = 16462,

  /**
   * @generated from enum value: VID_ROOM_TEST_CLOUD_MODEL_VENTILATION_DEVICE_ID_0XC01B = 4095;
   */
  VID_ROOM_TEST_CLOUD_MODEL_VENTILATION_DEVICE_ID_0XC01B = 4095,

  /**
   * @generated from enum value: VID_ROOM_THERMAL_INTEGRATION_HYSTERESIS = 33846;
   */
  VID_ROOM_THERMAL_INTEGRATION_HYSTERESIS = 33846,

  /**
   * @generated from enum value: VID_ROOM_THERMAL_INTEGRATION_INTEGRATION_OFFSET_HEATING = 33845;
   */
  VID_ROOM_THERMAL_INTEGRATION_INTEGRATION_OFFSET_HEATING = 33845,

  /**
   * @generated from enum value: VID_ROOM_VENTILATION_DEVICE_ID = 49179;
   */
  VID_ROOM_VENTILATION_DEVICE_ID = 49179,

  /**
   * @generated from enum value: VID_ROOM_VOC_CONTROLLER_BLOCKING = 35;
   */
  VID_ROOM_VOC_CONTROLLER_BLOCKING = 35,

  /**
   * @generated from enum value: VID_ROOM_VOC_CONTROLLER_STATE = 34;
   */
  VID_ROOM_VOC_CONTROLLER_STATE = 34,

  /**
   * @generated from enum value: VID_ROOM_WARNING_CO2_ABOVE_WARNING_LEVEL = 50199;
   */
  VID_ROOM_WARNING_CO2_ABOVE_WARNING_LEVEL = 50199,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_DEADTIME = 33005;
   */
  VID_SERVO_OUTPUT_DEADTIME = 33005,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_REBOUND = 33004;
   */
  VID_SERVO_OUTPUT_REBOUND = 33004,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_REQUEST = 67;
   */
  VID_SERVO_OUTPUT_REQUEST = 67,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_RUNTIME = 33002;
   */
  VID_SERVO_OUTPUT_RUNTIME = 33002,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_TYPE = 33001;
   */
  VID_SERVO_OUTPUT_TYPE = 33001,

  /**
   * @generated from enum value: VID_SERVO_OUTPUT_WINDUP = 33003;
   */
  VID_SERVO_OUTPUT_WINDUP = 33003,

  /**
   * @generated from enum value: VID_TEST_SUPPORT_BUS_PACKET_TIME_BRANCH_SPECIFIC = 34014;
   */
  VID_TEST_SUPPORT_BUS_PACKET_TIME_BRANCH_SPECIFIC = 34014,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_ALLOW_MODE = 33836;
   */
  VID_THERMAL_INTEGRATION_ALLOW_MODE = 33836,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_BLOCKING = 151;
   */
  VID_THERMAL_INTEGRATION_BLOCKING = 151,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_CONSUMER_LIST = 33838;
   */
  VID_THERMAL_INTEGRATION_CONSUMER_LIST = 33838,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_CONTROLLER_REQUIRED_COOLING_WATER_TEMP = 33854;
   */
  VID_THERMAL_INTEGRATION_CONTROLLER_REQUIRED_COOLING_WATER_TEMP = 33854,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_CONTROLLER_REQUIRED_HEATING_WATER_TEMP = 33853;
   */
  VID_THERMAL_INTEGRATION_CONTROLLER_REQUIRED_HEATING_WATER_TEMP = 33853,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_DEMAND_CONDITION = 33837;
   */
  VID_THERMAL_INTEGRATION_DEMAND_CONDITION = 33837,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_DEMAND_ROOM_OID = 33932;
   */
  VID_THERMAL_INTEGRATION_DEMAND_ROOM_OID = 33932,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_SOURCE_DEMAND = 149;
   */
  VID_THERMAL_INTEGRATION_SOURCE_DEMAND = 149,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_SOURCE_STATUS = 150;
   */
  VID_THERMAL_INTEGRATION_SOURCE_STATUS = 150,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_SOURCE_SUPPLIER_OID = 33839;
   */
  VID_THERMAL_INTEGRATION_SOURCE_SUPPLIER_OID = 33839,

  /**
   * @generated from enum value: VID_THERMAL_INTEGRATION_STATE = 154;
   */
  VID_THERMAL_INTEGRATION_STATE = 154,

  /**
   * @generated from enum value: VID_THERMOHEAD_OUTPUT_FIRST_OPEN_PERFORMED = 33927;
   */
  VID_THERMOHEAD_OUTPUT_FIRST_OPEN_PERFORMED = 33927,

  /**
   * @generated from enum value: VID_THERMOHEAD_OUTPUT_LOAD_DETECTED = 176;
   */
  VID_THERMOHEAD_OUTPUT_LOAD_DETECTED = 176,

  /**
   * @generated from enum value: VID_THERMOHEAD_OUTPUT_LOAD_POWER = 190;
   */
  VID_THERMOHEAD_OUTPUT_LOAD_POWER = 190,

  /**
   * @generated from enum value: VID_THERMOHEAD_OUTPUT_LOAD_TYPE = 33916;
   */
  VID_THERMOHEAD_OUTPUT_LOAD_TYPE = 33916,

  /**
   * @generated from enum value: VID_THERMOHEAD_OUTPUT_WARN_NO_LOAD = 16496;
   */
  VID_THERMOHEAD_OUTPUT_WARN_NO_LOAD = 16496,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_EMUL_END_STATE = 33068;
   */
  VID_UPDATE_CONTROLLER_EMUL_END_STATE = 33068,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_EMUL_FORCE_CCU_UPDATE = 33079;
   */
  VID_UPDATE_CONTROLLER_EMUL_FORCE_CCU_UPDATE = 33079,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_EMUL_OFFLINE_DEVICES = 33078;
   */
  VID_UPDATE_CONTROLLER_EMUL_OFFLINE_DEVICES = 33078,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_EMUL_ONLINE_DEVICES = 33069;
   */
  VID_UPDATE_CONTROLLER_EMUL_ONLINE_DEVICES = 33069,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_NEXT_UPDATE_CHECK = 33084;
   */
  VID_UPDATE_CONTROLLER_NEXT_UPDATE_CHECK = 33084,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_REPORT_STATE_TIME = 33082;
   */
  VID_UPDATE_CONTROLLER_REPORT_STATE_TIME = 33082,

  /**
   * @generated from enum value: VID_UPDATE_CONTROLLER_WARNING_CRITICAL_UPDATE_AVAILABLE = 16428;
   */
  VID_UPDATE_CONTROLLER_WARNING_CRITICAL_UPDATE_AVAILABLE = 16428,

  /**
   * @generated from enum value: VID_USB_LOG_MASK = 34017;
   */
  VID_USB_LOG_MASK = 34017,

  /**
   * @generated from enum value: VID_USB_LOG_PERIOD = 34018;
   */
  VID_USB_LOG_PERIOD = 34018,

  /**
   * @generated from enum value: VID_USB_NEW_FIRMWARE_AVAILABLE = 272;
   */
  VID_USB_NEW_FIRMWARE_AVAILABLE = 272,

  /**
   * @generated from enum value: VID_USB_STATE = 259;
   */
  VID_USB_STATE = 259,

  /**
   * @generated from enum value: VID_VALVEHEAD_OUTPUT_DISCOVERED_FULLY_CLOSED_FULLY_OPENED_POSITIONS = 264;
   */
  VID_VALVEHEAD_OUTPUT_DISCOVERED_FULLY_CLOSED_FULLY_OPENED_POSITIONS = 264,

  /**
   * @generated from enum value: VID_VALVEHEAD_OUTPUT_DISCOVERED_WORKING_SPAN_DEPRECATED = 261;
   */
  VID_VALVEHEAD_OUTPUT_DISCOVERED_WORKING_SPAN_DEPRECATED = 261,

  /**
   * @generated from enum value: VID_VALVEHEAD_OUTPUT_OUTPUT_DEMAND = 106;
   */
  VID_VALVEHEAD_OUTPUT_OUTPUT_DEMAND = 106,

  /**
   * @generated from enum value: VID_VALVEHEAD_OUTPUT_OUTPUT_DEMAND_THRESHOLD = 33893;
   */
  VID_VALVEHEAD_OUTPUT_OUTPUT_DEMAND_THRESHOLD = 33893,

  /**
   * @generated from enum value: VID_VALVEHEAD_OUTPUT_WORKING_SPAN_PRESET_MM = 34013;
   */
  VID_VALVEHEAD_OUTPUT_WORKING_SPAN_PRESET_MM = 34013,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_BLINDS_POSITION = 133;
   */
  VID_VELUX_CONTROLLER_BLINDS_POSITION = 133,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_BLINDS_POSITION_REQUEST = 134;
   */
  VID_VELUX_CONTROLLER_BLINDS_POSITION_REQUEST = 134,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_BLINDS_STATE = 132;
   */
  VID_VELUX_CONTROLLER_BLINDS_STATE = 132,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_COMMAND = 128;
   */
  VID_VELUX_CONTROLLER_COMMAND = 128,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_CONNECTION_IP_ADDRESS = 33100;
   */
  VID_VELUX_CONTROLLER_CONNECTION_IP_ADDRESS = 33100,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_CONNECTION_PASSWORD = 33101;
   */
  VID_VELUX_CONTROLLER_CONNECTION_PASSWORD = 33101,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_CONNECTION_STATE = 127;
   */
  VID_VELUX_CONTROLLER_CONNECTION_STATE = 127,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_ROLLER_SHUTTER_POSITION = 130;
   */
  VID_VELUX_CONTROLLER_ROLLER_SHUTTER_POSITION = 130,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_ROLLER_SHUTTER_POSITION_REQUEST = 131;
   */
  VID_VELUX_CONTROLLER_ROLLER_SHUTTER_POSITION_REQUEST = 131,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_ROLLER_SHUTTER_STATE = 129;
   */
  VID_VELUX_CONTROLLER_ROLLER_SHUTTER_STATE = 129,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_WINDOW_OPENER_POSITION = 136;
   */
  VID_VELUX_CONTROLLER_WINDOW_OPENER_POSITION = 136,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_WINDOW_OPENER_POSITION_REQUEST = 137;
   */
  VID_VELUX_CONTROLLER_WINDOW_OPENER_POSITION_REQUEST = 137,

  /**
   * @generated from enum value: VID_VELUX_CONTROLLER_WINDOW_OPENER_STATE = 135;
   */
  VID_VELUX_CONTROLLER_WINDOW_OPENER_STATE = 135,
}

/**
 * Describes the enum wavin.sentio.v1.VID.
 */
export const VIDSchema: GenEnum<VID> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_broker, 5);

